import ze, { useMemo as te, useCallback as he, useReducer as ss, useContext as Te, useState as G, useEffect as de, useRef as ns, memo as qr, createContext as Hr } from "react";
import { useSelectedConcepts as as, useEntityList as is, ModalContext as cr, DialogContext as os, useEntityNew as ls } from "@prometheus/hooks";
import { Tooltip as dr, Grid as y, Block as pr, BlockTitle as us, Icon as pe, NewTable as cs, FilterPanel as ds, InputFilter as ps, useNotifications as yr, ContentBlock as Qr, Table as Xr, Typography as W, Spinner as _e, Button as Ae, Paper as ys, Input as Oe, Select as Fe, EditableInput as Mr, IconActionButton as $e, Box as ue, Divider as ms } from "@prometheus/components";
import { ID_COLUMN as mr, NAME_COLUMN as fr, CREATED_COLUMN as Er, UPDATED_COLUMN as Cr, AUTHOR_COLUMN as hr, EntityTypeCell as Xe, NameCell as Tr, ActionCell as Jr, ICON_COLUMN as Kr, FloatingButton as fs, SpinnerWidgetContainer as ve, TabsNavigationNew as Zr, RemoveButton as Es, FormElement as Ie, FormActionsContainer as et, PageList as rt, InlineFormElement as Cs, CodeEditor as hs, TabWithCounter as Ts, ErrorPage as tr, SpinnerContainer as tt, NestedInfoWrapper as st, ExportMultipleSource as xs, PublishEntity as gs, ConfirmationDialog as As, useArchiveLibraryMember as Rs, FeatureAnalysisBaseInfo as Is } from "@prometheus/features";
import { NameConflictResolution as xr, TypesOfContainer as ne, EntityIconNames as Je, EntityTypes as bs } from "@prometheus/enums";
import { api as q, getSortDirection as gr, createSortingMethodListConfig as Ar, createFiltersPanelListConfig as We, populateColumnsConfigWithSort as _s, separateSearchFilters as Os, getReducerWithProduce as vs, getUUID as Rr, createCrudMethodsListConfig as nt, createBreadcrumbsEntityConfig as at, createCrudEntityConfig as it, getFormatDateAndTime as Ss, isEqual as Fr, parseActions as ot, convertExtendedToLegacyConcepts as Ns } from "@prometheus/utils";
import { Status as re } from "@prometheus/types";
import { useNavigate as lt, useParams as ut, useSearchParams as js, useLocation as Ds, Routes as ct, Route as qe } from "react-router-dom";
import { useDispatch as dt } from "react-redux";
import { setBreadcrumbs as pt } from "@prometheus/redux";
import { useTheme as Us } from "@emotion/react";
var sr = { exports: {} }, je = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lr;
function ws() {
  if (Lr) return je;
  Lr = 1;
  var e = Symbol.for("react.transitional.element"), r = Symbol.for("react.fragment");
  function t(s, a, i) {
    var l = null;
    if (i !== void 0 && (l = "" + i), a.key !== void 0 && (l = "" + a.key), "key" in a) {
      i = {};
      for (var u in a)
        u !== "key" && (i[u] = a[u]);
    } else i = a;
    return a = i.ref, {
      $$typeof: e,
      type: s,
      key: l,
      ref: a !== void 0 ? a : null,
      props: i
    };
  }
  return je.Fragment = r, je.jsx = t, je.jsxs = t, je;
}
var De = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pr;
function Ms() {
  return Pr || (Pr = 1, process.env.NODE_ENV !== "production" && function() {
    function e(o) {
      if (o == null) return null;
      if (typeof o == "function")
        return o.$$typeof === Z ? null : o.displayName || o.name || null;
      if (typeof o == "string") return o;
      switch (o) {
        case j:
          return "Fragment";
        case T:
          return "Profiler";
        case L:
          return "StrictMode";
        case D:
          return "Suspense";
        case $:
          return "SuspenseList";
        case U:
          return "Activity";
      }
      if (typeof o == "object")
        switch (typeof o.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), o.$$typeof) {
          case E:
            return "Portal";
          case C:
            return (o.displayName || "Context") + ".Provider";
          case A:
            return (o._context.displayName || "Context") + ".Consumer";
          case m:
            var g = o.render;
            return o = o.displayName, o || (o = g.displayName || g.name || "", o = o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef"), o;
          case Q:
            return g = o.displayName || null, g !== null ? g : e(o.type) || "Memo";
          case V:
            g = o._payload, o = o._init;
            try {
              return e(o(g));
            } catch {
            }
        }
      return null;
    }
    function r(o) {
      return "" + o;
    }
    function t(o) {
      try {
        r(o);
        var g = !1;
      } catch {
        g = !0;
      }
      if (g) {
        g = console;
        var w = g.error, O = typeof Symbol == "function" && Symbol.toStringTag && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return w.call(
          g,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          O
        ), r(o);
      }
    }
    function s(o) {
      if (o === j) return "<>";
      if (typeof o == "object" && o !== null && o.$$typeof === V)
        return "<...>";
      try {
        var g = e(o);
        return g ? "<" + g + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function a() {
      var o = R.A;
      return o === null ? null : o.getOwner();
    }
    function i() {
      return Error("react-stack-top-frame");
    }
    function l(o) {
      if (b.call(o, "key")) {
        var g = Object.getOwnPropertyDescriptor(o, "key").get;
        if (g && g.isReactWarning) return !1;
      }
      return o.key !== void 0;
    }
    function u(o, g) {
      function w() {
        Y || (Y = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          g
        ));
      }
      w.isReactWarning = !0, Object.defineProperty(o, "key", {
        get: w,
        configurable: !0
      });
    }
    function d() {
      var o = e(this.type);
      return ie[o] || (ie[o] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), o = this.props.ref, o !== void 0 ? o : null;
    }
    function c(o, g, w, O, B, X, le, ae) {
      return w = X.ref, o = {
        $$typeof: S,
        type: o,
        key: g,
        props: X,
        _owner: B
      }, (w !== void 0 ? w : null) !== null ? Object.defineProperty(o, "ref", {
        enumerable: !1,
        get: d
      }) : Object.defineProperty(o, "ref", { enumerable: !1, value: null }), o._store = {}, Object.defineProperty(o._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(o, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(o, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: le
      }), Object.defineProperty(o, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ae
      }), Object.freeze && (Object.freeze(o.props), Object.freeze(o)), o;
    }
    function x(o, g, w, O, B, X, le, ae) {
      var H = g.children;
      if (H !== void 0)
        if (O)
          if (ee(H)) {
            for (O = 0; O < H.length; O++)
              f(H[O]);
            Object.freeze && Object.freeze(H);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else f(H);
      if (b.call(g, "key")) {
        H = e(o);
        var Ee = Object.keys(g).filter(function(Ge) {
          return Ge !== "key";
        });
        O = 0 < Ee.length ? "{key: someKey, " + Ee.join(": ..., ") + ": ...}" : "{key: someKey}", k[H + O] || (Ee = 0 < Ee.length ? "{" + Ee.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          O,
          H,
          Ee,
          H
        ), k[H + O] = !0);
      }
      if (H = null, w !== void 0 && (t(w), H = "" + w), l(g) && (t(g.key), H = "" + g.key), "key" in g) {
        w = {};
        for (var Ne in g)
          Ne !== "key" && (w[Ne] = g[Ne]);
      } else w = g;
      return H && u(
        w,
        typeof o == "function" ? o.displayName || o.name || "Unknown" : o
      ), c(
        o,
        H,
        X,
        B,
        a(),
        w,
        le,
        ae
      );
    }
    function f(o) {
      typeof o == "object" && o !== null && o.$$typeof === S && o._store && (o._store.validated = 1);
    }
    var h = ze, S = Symbol.for("react.transitional.element"), E = Symbol.for("react.portal"), j = Symbol.for("react.fragment"), L = Symbol.for("react.strict_mode"), T = Symbol.for("react.profiler"), A = Symbol.for("react.consumer"), C = Symbol.for("react.context"), m = Symbol.for("react.forward_ref"), D = Symbol.for("react.suspense"), $ = Symbol.for("react.suspense_list"), Q = Symbol.for("react.memo"), V = Symbol.for("react.lazy"), U = Symbol.for("react.activity"), Z = Symbol.for("react.client.reference"), R = h.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, b = Object.prototype.hasOwnProperty, ee = Array.isArray, J = console.createTask ? console.createTask : function() {
      return null;
    };
    h = {
      react_stack_bottom_frame: function(o) {
        return o();
      }
    };
    var Y, ie = {}, oe = h.react_stack_bottom_frame.bind(
      h,
      i
    )(), P = J(s(i)), k = {};
    De.Fragment = j, De.jsx = function(o, g, w, O, B) {
      var X = 1e4 > R.recentlyCreatedOwnerStacks++;
      return x(
        o,
        g,
        w,
        !1,
        O,
        B,
        X ? Error("react-stack-top-frame") : oe,
        X ? J(s(o)) : P
      );
    }, De.jsxs = function(o, g, w, O, B) {
      var X = 1e4 > R.recentlyCreatedOwnerStacks++;
      return x(
        o,
        g,
        w,
        !0,
        O,
        B,
        X ? Error("react-stack-top-frame") : oe,
        X ? J(s(o)) : P
      );
    };
  }()), De;
}
process.env.NODE_ENV === "production" ? sr.exports = ws() : sr.exports = Ms();
var n = sr.exports, N = /* @__PURE__ */ ((e) => (e.PRESET = "PRESET", e.CRITERIA_SET = "CRITERIA_SET", e.CUSTOM_SQL = "CUSTOM_SQL", e))(N || {}), me = /* @__PURE__ */ ((e) => (e.CUSTOM_FE = "CUSTOM_FE", e.CRITERIA_SET = "CRITERIA_SET", e))(me || {}), _ = /* @__PURE__ */ ((e) => (e.DISTRIBUTION = "DISTRIBUTION", e.PREVALENCE = "PREVALENCE", e.CUSTOM = "CUSTOM", e))(_ || {}), K = /* @__PURE__ */ ((e) => (e.EVENTS_COUNT = "EVENTS_COUNT", e))(K || {}), z = /* @__PURE__ */ ((e) => (e.ARTIFACTS_LIBRARY = "ARTIFACTS_LIBRARY", e.CUSTOM_FEATURE_STORE = "CUSTOM_FEATURE_STORE", e))(z || {});
const yt = [
  { value: _.DISTRIBUTION, name: "Distribution" },
  { value: _.PREVALENCE, name: "Prevalence" },
  { value: _.CUSTOM, name: "Custom" }
];
N.CRITERIA_SET, N.CUSTOM_SQL;
const mt = [
  { value: "DEMOGRAPHICS", name: "Demographics" },
  { value: "CONDITION", name: "Condition" },
  { value: "DRUG", name: "Drug" },
  { value: "MEASUREMENT", name: "Measurement" },
  { value: "OBSERVATION", name: "Observation" },
  { value: "PROCEDURE", name: "Procedure" },
  { value: "DEVICE", name: "Device" },
  { value: "VISIT", name: "Visit" }
], Fs = [
  {
    value: K.EVENTS_COUNT,
    name: "Events count"
  }
], Ls = [
  { value: "DISTINCT_START_DAYS", name: "Distinct start days" },
  { value: "DURATION", name: "Duration" },
  { value: "DURATION_AVERAGE", name: "Duration (average)" },
  { value: "DURATION_MAX", name: "Duration (max)" },
  { value: "DURATION_MIN", name: "Duration (min)" },
  { value: K.EVENTS_COUNT, name: "Events count" }
], Ps = {
  CONDITION_ERA: [
    { value: "CONDITION_OCCURRENCE_COUNT", name: "Condition occurrence count" },
    {
      value: "CONDITION_OCCURRENCE_COUNT_AVERAGE",
      name: "Condition occurrence count (average)"
    },
    {
      value: "CONDITION_OCCURRENCE_COUNT_MAX",
      name: "Condition occurrence count (max)"
    },
    {
      value: "CONDITION_OCCURRENCE_COUNT_MIN",
      name: "Condition occurrence count (min)"
    }
  ],
  DRUG_ERA: [
    { value: "DRUG_EXPOSURE_COUNT", name: "Drug exposure count" },
    {
      value: "DRUG_EXPOSURE_COUNT_AVERAGE",
      name: "Drug exposure count (average)"
    },
    { value: "DRUG_EXPOSURE_COUNT_MAX", name: "Drug exposure count (max)" },
    { value: "DRUG_EXPOSURE_COUNT_MIN", name: "Drug exposure count (min)" },
    { value: "GAP_DAYS", name: "Gap days" },
    { value: "GAP_DAYS_AVERAGE", name: "Gap days (average)" },
    { value: "GAP_DAYS_MAX", name: "Gap days (max)" },
    { value: "GAP_DAYS_MIN", name: "Gap days (min)" }
  ],
  DRUG_EXPOSURE: [
    { value: "DAYS_SUPPLY", name: "Days supply" },
    { value: "DAYS_SUPPLY_AVERAGE", name: "Days supply (average)" },
    { value: "DAYS_SUPPLY_MAX", name: "Days supply (max)" },
    { value: "DAYS_SUPPLY_MIN", name: "Days supply (min)" },
    { value: "QUANTITY", name: "Quantity" },
    { value: "QUANTITY_AVERAGE", name: "Quantity (average)" },
    { value: "QUANTITY_MAX", name: "Quantity (max)" },
    { value: "QUANTITY_MIN", name: "Quantity (min)" },
    { value: "REFILLS", name: "Refills" },
    { value: "REFILLS_AVERAGE", name: "Refills (average)" },
    { value: "REFILLS_MAX", name: "Refills (max)" },
    { value: "REFILLS_MIN", name: "Refills (min)" }
  ],
  MEASUREMENT: [
    { value: "RANGE_HIGH", name: "Range high" },
    { value: "RANGE_HIGH_AVERAGE", name: "Range high (average)" },
    { value: "RANGE_HIGH_MAX", name: "Range high (max)" },
    { value: "RANGE_HIGH_MIN", name: "Range high (min)" },
    { value: "RANGE_LOW", name: "Range low" },
    { value: "RANGE_LOW_AVERAGE", name: "Range low (average)" },
    { value: "RANGE_LOW_MAX", name: "Range low (max)" },
    { value: "RANGE_LOW_MIN", name: "Range low (min)" },
    { value: "VALUE_AS_NUMBER", name: "Value as number" },
    { value: "VALUE_AS_NUMBER_AVERAGE", name: "Value as number (average)" },
    { value: "VALUE_AS_NUMBER_MAX", name: "Value as number (max)" },
    { value: "VALUE_AS_NUMBER_MIN", name: "Value as number (min)" }
  ],
  OBSERVATION: [
    { value: "VALUE_AS_NUMBER", name: "Value as number" },
    { value: "VALUE_AS_NUMBER_AVERAGE", name: "Value as number (average)" },
    { value: "VALUE_AS_NUMBER_MAX", name: "Value as number (max)" },
    { value: "VALUE_AS_NUMBER_MIN", name: "Value as number (min)" }
  ],
  PROCEDURE_OCCURRENCE: [
    { value: "QUANTITY", name: "Quantity" },
    { value: "QUANTITY_AVERAGE", name: "Quantity (average)" },
    { value: "QUANTITY_MAX", name: "Quantity (max)" },
    { value: "QUANTITY_MIN", name: "Quantity (min)" }
  ]
}, Bs = {
  CONDITIONERA: "CONDITION_ERA",
  DRUGERA: "DRUG_ERA",
  DRUGEXPOSURE: "DRUG_EXPOSURE",
  PROCEDUREOCCURRENCE: "PROCEDURE_OCCURRENCE",
  PAYERPLANPERIOD: "PAYER_PLAN_PERIOD",
  DEMOGRAPHIC: "DEMOGRAPHIC",
  DEMOGRAPHICS: "DEMOGRAPHIC",
  MEASUREMENT: "MEASUREMENT",
  OBSERVATION: "OBSERVATION",
  CONDITIONOCCURRENCE: "CONDITION_OCCURRENCE"
}, Vs = (e) => Bs[e.replace(/[^a-zA-Z]/g, "").toUpperCase()] || e.replace(/[^a-zA-Z]/g, "").toUpperCase(), ft = (e) => {
  const r = /* @__PURE__ */ new Set(), t = (s) => {
    if (!(!s || typeof s != "object")) {
      if (s.expression && typeof s.expression == "object") {
        t(s.expression);
        return;
      }
      Array.isArray(s.DemographicCriteriaList) && s.DemographicCriteriaList.length && r.add("DEMOGRAPHIC"), Array.isArray(s.CriteriaList) && s.CriteriaList.forEach((a) => {
        const i = a == null ? void 0 : a.Criteria;
        i && typeof i == "object" && Object.keys(i).forEach((l) => {
          r.add(Vs(l));
        });
      }), Array.isArray(s.Groups) && s.Groups.forEach(t);
    }
  };
  return (e || []).forEach(t), Array.from(r);
}, ks = (e) => {
  const r = ft(e);
  if (!r.length)
    return Fs;
  const t = /* @__PURE__ */ new Map();
  return r.some((a) => a !== "DEMOGRAPHIC") ? Ls.forEach((a) => {
    t.set(a.value, a);
  }) : t.set(K.EVENTS_COUNT, {
    value: K.EVENTS_COUNT,
    name: "Events count"
  }), r.forEach((a) => {
    (Ps[a] || []).forEach((l) => {
      t.set(l.value, l);
    });
  }), Array.from(t.values());
}, Et = (e) => ft([e]).some((r) => r !== "DEMOGRAPHIC"), Ct = (e) => ks([e]), Ir = {
  [_.DISTRIBUTION]: {
    allowedSubtypes: [N.CRITERIA_SET],
    supportsCriteria: !0,
    supportsSql: !1,
    supportsDistributeBy: !0,
    defaultDistributeBy: K.EVENTS_COUNT
  },
  [_.PREVALENCE]: {
    allowedSubtypes: [N.CRITERIA_SET],
    supportsCriteria: !0,
    supportsSql: !1,
    supportsDistributeBy: !1,
    defaultDistributeBy: ""
  },
  [_.CUSTOM]: {
    allowedSubtypes: [N.CUSTOM_SQL],
    supportsCriteria: !1,
    supportsSql: !0,
    supportsDistributeBy: !1,
    defaultDistributeBy: ""
  }
}, Gs = (e) => e === N.CUSTOM_SQL ? me.CUSTOM_FE : me.CRITERIA_SET, $s = [
  "@cdm_database_schema",
  "@cohort_table",
  "@cohort_id",
  "@analysis_id",
  "@vocabulary_database_schema",
  "@result_database_schema"
], Ys = `-- Custom analysis producing same results as Feature Extraction's "One covariate per drug in the drug_era table overlapping with any time prior to index."
SELECT
  CAST(drug_concept_id AS BIGINT) * 1000 + @analysis_id AS covariate_id,
  c.concept_name AS covariate_name,
  drug_concept_id AS concept_id,
  COUNT(*) AS sum_value,
  COUNT(*) * 1.0 / stat.total_cnt * 1.0 AS average_value
FROM (
  SELECT DISTINCT
    drug_concept_id,
    cohort.subject_id,
    cohort.cohort_start_date
  FROM @cohort_table cohort
  INNER JOIN @cdm_database_schema.drug_era ON cohort.subject_id = drug_era.person_id
  WHERE drug_era_start_date <= cohort.cohort_start_date
    AND drug_concept_id != 0
    AND cohort.cohort_definition_id = @cohort_id
) drug_entries
JOIN @cdm_database_schema.concept c ON drug_entries.drug_concept_id = c.concept_id
CROSS JOIN (
  SELECT COUNT(*) total_cnt
  FROM @cohort_table
  WHERE cohort_definition_id = @cohort_id
) stat
GROUP BY drug_concept_id, c.concept_name, stat.total_cnt`, br = "new", nr = "CriteriaGroup", He = "WindowedCriteria", _r = "DemographicCriteria", ht = "DISTINCT_START_DAYS", Tt = "START_DATE", ar = "DISTINCT v.start_date", ir = {
  Type: "ALL",
  CriteriaList: [],
  DemographicCriteriaList: [],
  Groups: []
}, zs = {
  AVERAGE: "AVG",
  MAX: "MAX",
  MIN: "MIN"
}, Ws = {
  CONDITION: "ConditionOccurrence",
  CONDITIONOCCURRENCE: "ConditionOccurrence",
  CONDITIONERA: "ConditionEra",
  DEATH: "Death",
  DEVICE: "DeviceExposure",
  DEVICEEXPOSURE: "DeviceExposure",
  DOSEERA: "DoseEra",
  DRUG: "DrugExposure",
  DRUGEXPOSURE: "DrugExposure",
  DRUGERA: "DrugEra",
  LOCATION: "LocationRegion",
  LOCATIONREGION: "LocationRegion",
  MEASUREMENT: "Measurement",
  OBSERVATION: "Observation",
  OBSERVATIONPERIOD: "ObservationPeriod",
  PAYERPLANPERIOD: "PayerPlanPeriod",
  PROCEDURE: "ProcedureOccurrence",
  PROCEDUREOCCURRENCE: "ProcedureOccurrence",
  SPECIMEN: "Specimen",
  VISIT: "VisitOccurrence",
  VISITOCCURRENCE: "VisitOccurrence",
  VISITDETAIL: "VisitDetail"
}, F = (e) => typeof e == "string" ? e : "", Re = (e) => Array.isArray(e) ? e[0] : e, xe = (e) => F(Re(e)), qs = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i, Br = (e) => typeof e == "string" && qs.test(e), Hs = (e) => Ws[e.replace(/[^a-zA-Z]/g, "").toUpperCase()] || e, xt = (e, r) => {
  if (typeof e == "number" && Number.isFinite(e))
    return e;
  if (typeof e == "string" && e.trim()) {
    const t = Number(e);
    if (Number.isFinite(t))
      return t;
  }
  return r;
}, gt = (e) => e ? Array.isArray(e) ? e.map((r) => ({
  concept: (r == null ? void 0 : r.concept) || {},
  includeDescendants: (r == null ? void 0 : r.includeDescendants) ?? (r == null ? void 0 : r.descendants) ?? !1,
  includeMapped: (r == null ? void 0 : r.includeMapped) ?? (r == null ? void 0 : r.mapped) ?? !1,
  isExcluded: (r == null ? void 0 : r.isExcluded) ?? (r == null ? void 0 : r.excluded) ?? !1,
  hierarchy: (r == null ? void 0 : r.hierarchy) ?? !1,
  id: r == null ? void 0 : r.id
})) : typeof e == "object" ? Object.values(e).map((r) => ({
  concept: (r == null ? void 0 : r.concept) || {},
  includeDescendants: (r == null ? void 0 : r.includeDescendants) ?? (r == null ? void 0 : r.descendants) ?? !1,
  includeMapped: (r == null ? void 0 : r.includeMapped) ?? (r == null ? void 0 : r.mapped) ?? !1,
  isExcluded: (r == null ? void 0 : r.isExcluded) ?? (r == null ? void 0 : r.excluded) ?? !1,
  hierarchy: (r == null ? void 0 : r.hierarchy) ?? !1,
  id: r == null ? void 0 : r.id
})) : [] : [], Le = (e) => Array.isArray(e) ? e.length > 0 : e && typeof e == "object" ? Object.keys(e).length > 0 : !1, Qs = (e = []) => e.reduce((r, t, s) => {
  const a = xt(t == null ? void 0 : t.externalId, s);
  return [
    t == null ? void 0 : t.id,
    t == null ? void 0 : t.uuid,
    t == null ? void 0 : t.referenceId,
    t == null ? void 0 : t.externalId
  ].forEach((i) => {
    i != null && r.set(String(i), a);
  }), r;
}, /* @__PURE__ */ new Map()), Xs = {
  CodesetId: "CodesetId",
  DrugCodesetId: "DrugCodesetId",
  codesetId: "CodesetId",
  drugCodesetId: "DrugCodesetId"
}, Qe = (e, r) => Array.isArray(e) ? e.map(
  (t) => Qe(t, r)
) : !e || typeof e != "object" ? e : Object.keys(e).reduce((t, s) => {
  const a = e[s], i = Xs[s];
  if (i && a != null) {
    const l = r.has(
      String(a)
    ) ? r.get(String(a)) : a;
    return (s === i || e[i] == null) && (t[i] = l), t;
  }
  return t[s] = Qe(a, r), t;
}, {}), At = (e) => {
  if (typeof e != "string")
    return e;
  const r = e.trim();
  if (!["{", "["].includes(r[0]))
    return e;
  try {
    return JSON.parse(r);
  } catch {
    return e;
  }
}, ge = (e) => {
  const r = At(e);
  return Array.isArray(r) ? r.map(ge) : !r || typeof r != "object" ? r : Array.isArray(r.CriteriaList) || Array.isArray(r.DemographicCriteriaList) || Array.isArray(r.Groups) ? Se(r) : Object.keys(r).reduce((t, s) => (t[s] = ge(r[s]), t), {});
}, Rt = (e) => {
  if (!e || typeof e != "object" || !e.Criteria)
    return ge(e);
  const r = Object.entries(e.Criteria);
  if (!r.length)
    return ge(e);
  const [t, s] = r[0], a = Hs(t);
  return {
    ...e,
    Criteria: {
      [a]: ge(s)
    }
  };
};
function Se(e) {
  const r = At(e), t = r && typeof r == "object" ? r : ir;
  return {
    ...t,
    Type: t.Type || ir.Type,
    CriteriaList: Array.isArray(t.CriteriaList) ? t.CriteriaList.map(Rt) : [],
    DemographicCriteriaList: Array.isArray(t.DemographicCriteriaList) ? t.DemographicCriteriaList.map(ge) : [],
    Groups: Array.isArray(t.Groups) ? t.Groups.map(Se) : []
  };
}
const Js = (e) => {
  if (Array.isArray(e) || e && typeof e == "object")
    return e;
  if (typeof e != "string")
    return null;
  const r = e.trim();
  if (!r)
    return "";
  if (!["{", "["].includes(r[0]))
    return e;
  try {
    return JSON.parse(r);
  } catch {
    return e;
  }
}, Pe = (e) => {
  switch (e) {
    case _.DISTRIBUTION:
    case "distribution":
      return _.DISTRIBUTION;
    case _.CUSTOM:
    case "custom":
      return _.CUSTOM;
    case _.PREVALENCE:
    case "prevalence":
    default:
      return _.PREVALENCE;
  }
}, Ks = (e, r) => {
  if (e.type === me.CUSTOM_FE)
    return _.CUSTOM;
  const t = F(e.statType || e.analysisType);
  if (t)
    return Pe(t);
  if (r && typeof r == "object" && !Array.isArray(r)) {
    if (r.analysisType)
      return Pe(r.analysisType);
    if (r.distributeBy || Array.isArray(r.criteriaGroups) && r.criteriaGroups.some(
      (s) => F(s == null ? void 0 : s.distributeBy)
    ))
      return _.DISTRIBUTION;
  }
  return Array.isArray(r) && r.some(
    (s) => F(s == null ? void 0 : s.distributeBy)
  ) ? _.DISTRIBUTION : _.PREVALENCE;
}, Zs = (e, r, t) => {
  var s;
  return e.type === me.CUSTOM_FE ? N.CUSTOM_SQL : e.type === me.CRITERIA_SET ? N.CRITERIA_SET : r === _.CUSTOM ? N.CUSTOM_SQL : Array.isArray((s = e == null ? void 0 : e.definition) == null ? void 0 : s.criteriaGroups) || Array.isArray(e == null ? void 0 : e.criteriaGroups) || Array.isArray(t) || t && typeof t == "object" && Array.isArray(t.criteriaGroups) ? N.CRITERIA_SET : N.PRESET;
}, It = (e, r, t, s) => {
  if (r === _.CUSTOM)
    return N.CUSTOM_SQL;
  switch (e) {
    case N.CRITERIA_SET:
      return N.CRITERIA_SET;
    case N.CUSTOM_SQL:
      return N.CUSTOM_SQL;
    case N.PRESET:
      return N.PRESET;
    default:
      return Zs(t, r, s);
  }
}, bt = (e) => {
  var r;
  return ((r = Ir[e]) == null ? void 0 : r.defaultDistributeBy) || K.EVENTS_COUNT;
}, _t = (e) => {
  const r = F(e).replace(/[^a-zA-Z]/g, "").toUpperCase();
  return ["EVENTSCOUNT", "EVENTCOUNT", "EVENTS"].includes(r);
}, Ot = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1_$2").replace(/[^a-zA-Z0-9]+/g, "_").replace(/^_+|_+$/g, "").toLowerCase(), be = (e) => {
  const r = F(e);
  return _t(r) ? K.EVENTS_COUNT : Ot(r).toUpperCase();
}, en = (e) => Ot(F(e)), Ze = (e) => {
  const r = be(e) || K.EVENTS_COUNT;
  if (r === K.EVENTS_COUNT)
    return {
      function: "COUNT",
      additionalColumns: [],
      expression: "*"
    };
  if (r === ht)
    return {
      function: "COUNT",
      additionalColumns: [Tt],
      expression: ar
    };
  const t = r.split("_"), s = t[t.length - 1], a = zs[s], i = a ? t.slice(0, -1).join("_") : r;
  return {
    function: a ?? null,
    additionalColumns: i ? [i] : [],
    expression: en(i)
  };
}, rn = (e) => {
  if (!e || typeof e != "object")
    return "";
  const r = F(e.function).toUpperCase(), t = Array.isArray(e.additionalColumns) ? be(e.additionalColumns[0]) : "", s = be(
    e.expression
  ), a = t || s;
  if (r === "COUNT" && (!a || _t(a)))
    return K.EVENTS_COUNT;
  if (r === "COUNT" && t === Tt && (F(e.expression).trim().toUpperCase() === ar.toUpperCase() || s === be(ar)))
    return ht;
  if (!a)
    return "";
  switch (r) {
    case "AVG":
      return `${a}_AVERAGE`;
    case "MAX":
      return `${a}_MAX`;
    case "MIN":
      return `${a}_MIN`;
    default:
      return a;
  }
}, vt = (e) => {
  const r = [...e.CriteriaList], t = [...e.DemographicCriteriaList];
  return e.Groups.forEach((s) => {
    const a = vt(s);
    r.push(...a.criteriaItems), t.push(...a.demographicCriteriaItems);
  }), { criteriaItems: r, demographicCriteriaItems: t };
}, tn = (e, r = /* @__PURE__ */ new Map()) => {
  const t = Or(
    e,
    r
  ), s = Se(
    t.expression
  ), a = be(e == null ? void 0 : e.distributeBy) || K.EVENTS_COUNT, i = Object.keys(t).reduce((x, f) => (["criteriaType", "distributeBy", "expression"].includes(f) || (x[f] = t[f]), x), {}), { criteriaItems: l, demographicCriteriaItems: u } = vt(s), d = l.map((x) => {
    const {
      Occurrence: f,
      mapDistinctField: h,
      ...S
    } = x;
    return {
      ...i,
      criteriaType: He,
      aggregate: Ze(a),
      expression: S
    };
  }), c = u.map(
    (x) => ({
      ...i,
      criteriaType: _r,
      aggregate: Ze(
        K.EVENTS_COUNT
      ),
      expression: x
    })
  );
  return !d.length && !c.length ? [
    {
      ...i,
      criteriaType: He,
      aggregate: Ze(a),
      expression: s
    }
  ] : [...d, ...c];
}, Or = (e, r = /* @__PURE__ */ new Map()) => {
  if (!e || typeof e != "object")
    return {
      criteriaType: nr,
      expression: Qe(
        Se(e),
        r
      )
    };
  const t = F(e.criteriaType) || nr, s = e.expression && typeof e.expression == "object" ? e.expression : e;
  return {
    ...e,
    criteriaType: t,
    expression: Qe(
      Se(s),
      r
    )
  };
}, sn = (e, r) => {
  const {
    aggregate: t,
    criteriaType: s,
    expression: a,
    ...i
  } = e || {}, l = F(e == null ? void 0 : e.criteriaType), u = e != null && e.expression && typeof e.expression == "object" ? e.expression : {}, d = rn(e == null ? void 0 : e.aggregate) || K.EVENTS_COUNT, c = {
    ...ir,
    CriteriaList: l === He ? [Rt(u)] : [],
    DemographicCriteriaList: l === _r ? [ge(u)] : []
  };
  return {
    ...i,
    criteriaType: nr,
    distributeBy: d,
    name: F(e == null ? void 0 : e.name) || F(e == null ? void 0 : e.title) || `Criteria group ${r + 1}`,
    description: F(e == null ? void 0 : e.description),
    expression: c
  };
}, Vr = (e, r) => {
  if ([
    He,
    _r
  ].includes(F(e == null ? void 0 : e.criteriaType)))
    return sn(e, r);
  const t = Or(e);
  return {
    ...t,
    name: F(t.name) || F(e == null ? void 0 : e.title) || `Criteria group ${r + 1}`,
    description: F(t.description),
    expression: Se(t.expression)
  };
}, St = (e, r, t) => {
  if (r !== _.DISTRIBUTION)
    return e;
  const s = t || bt(r);
  return e.map((a) => {
    if (!Et(a)) {
      const { distributeBy: d, ...c } = a;
      return c;
    }
    const i = Ct(
      a
    ).map((d) => d.value), l = be(
      a.distributeBy
    ), u = i.includes(s) ? s : K.EVENTS_COUNT;
    return {
      ...a,
      distributeBy: i.includes(l) ? l : u
    };
  });
}, vr = (e) => {
  var i;
  if (!e || typeof e != "object")
    return null;
  const r = [
    e.uuid,
    e.referenceId,
    e.id
  ].find(Br), t = [e.versionId, e.currentVersionId].find(
    Br
  );
  if (!r || !t)
    return null;
  const s = Le((i = e.expression) == null ? void 0 : i.items) ? e.expression.items : e.items || [];
  return {
    id: e.externalId !== void 0 && e.externalId !== null ? e.externalId : e.id,
    name: e.name || "New Concept set",
    expression: {
      ...e.expression,
      items: gt(s)
    },
    uuid: e.uuid || r,
    referenceId: r,
    externalId: e.externalId,
    versionId: t,
    currentVersionId: e.currentVersionId || t,
    version: e.version,
    versionOrdinal: e.versionOrdinal || e.version,
    currentVersionOrdinal: e.currentVersionOrdinal || e.versionOrdinal || e.version,
    terminated: e.terminated
  };
}, nn = (e, r = 0) => {
  var i;
  const t = vr(e);
  if (t)
    return t;
  if (!e || typeof e != "object")
    return null;
  const s = Le((i = e.expression) == null ? void 0 : i.items) ? e.expression.items : e.items || [];
  return Le(s) ? {
    id: Re(
      e.externalId ?? e.id ?? e.uuid ?? r
    ),
    name: xe(e.name) || xe(e.title) || "New Concept set",
    expression: {
      ...e.expression,
      items: gt(s)
    },
    uuid: xe(e.uuid) || void 0,
    referenceId: xe(e.referenceId) || void 0,
    externalId: Re(e.externalId ?? e.id),
    versionId: xe(e.versionId) || void 0,
    currentVersionId: xe(e.currentVersionId) || xe(e.versionId) || void 0,
    version: Re(e.version),
    versionOrdinal: Re(
      e.versionOrdinal ?? e.version
    ),
    currentVersionOrdinal: Re(
      e.currentVersionOrdinal ?? e.versionOrdinal ?? e.version
    ),
    terminated: e.terminated
  } : null;
}, Nt = (e, r = []) => (!e || typeof e != "object" || (Array.isArray(e.ConceptSets) && r.push(...e.ConceptSets), Array.isArray(e.Groups) && e.Groups.forEach(
  (t) => Nt(t, r)
)), r), an = (e = []) => e.flatMap(
  (r, t) => Nt(r == null ? void 0 : r.expression).map(
    (s, a) => nn(s, t + a)
  )
), on = (e = []) => {
  const r = /* @__PURE__ */ new Set(), t = [];
  return e.forEach((s) => {
    var i, l;
    if (!s)
      return;
    const a = String(
      s.externalId ?? s.id ?? s.uuid ?? s.referenceId ?? s.name
    );
    if (r.has(a)) {
      const u = t.findIndex(
        (f) => String(
          f.externalId ?? f.id ?? f.uuid ?? f.referenceId ?? f.name
        ) === a
      ), d = t[u], c = Le((i = s == null ? void 0 : s.expression) == null ? void 0 : i.items), x = Le(
        (l = d == null ? void 0 : d.expression) == null ? void 0 : l.items
      );
      c && !x && (t[u] = {
        ...s,
        ...d,
        expression: s.expression
      });
      return;
    }
    r.add(a), t.push(s);
  }), t;
}, ln = (e, r) => {
  const t = vr(e);
  return t ? {
    id: t.referenceId,
    versionId: t.versionId,
    externalId: xt(t.externalId, r)
  } : null;
}, Me = () => ({
  id: br,
  name: "",
  description: "",
  domain: "",
  analysisType: _.PREVALENCE,
  subtype: N.CRITERIA_SET,
  definition: {
    criteriaGroups: [],
    sql: "",
    distributeBy: ""
  },
  conceptSets: [],
  raw: {}
}), ye = (e) => {
  var S, E, j;
  if (!e)
    return Me();
  const r = Js(e.design), t = e.type ? Ks(e, r) : Pe(e.analysisType || e.statType), s = It(
    e.subtype || e.featureSubtype || e.faType,
    t,
    e,
    r
  ), a = r && typeof r == "object" && !Array.isArray(r) ? r : null, i = Array.isArray(r) ? r : Array.isArray(a == null ? void 0 : a.criteriaGroups) ? a.criteriaGroups : [], l = Array.isArray((S = e == null ? void 0 : e.definition) == null ? void 0 : S.criteriaGroups) ? e.definition.criteriaGroups : Array.isArray(e == null ? void 0 : e.criteriaGroups) ? e.criteriaGroups : [], u = i.length > 0 ? i.map(Vr) : l.map(Vr), d = F(
    ((E = e == null ? void 0 : e.definition) == null ? void 0 : E.distributeBy) || e.distributeBy || (a ? a.distributeBy : "")
  ) || (t === _.DISTRIBUTION ? bt(t) : ""), c = F(
    ((j = e == null ? void 0 : e.definition) == null ? void 0 : j.sql) || (e == null ? void 0 : e.sql) || (typeof r == "string" ? r : "")
  ), x = Array.isArray(e == null ? void 0 : e.conceptSets) ? e.conceptSets.map(vr) : [], f = an(u), h = on([
    ...x,
    ...f
  ]);
  return {
    id: F(e.id) || br,
    shortcut: F(e.shortcut) || void 0,
    name: F(e.name),
    description: F(e.description),
    domain: F(e.domain),
    analysisType: t,
    subtype: s,
    definition: {
      criteriaGroups: St(
        u,
        t,
        d
      ),
      sql: c,
      distributeBy: d
    },
    conceptSets: h,
    created: e.created,
    modified: e.modified,
    actions: e.actions,
    versionId: e.versionId,
    raw: e
  };
}, Ce = (e) => {
  var x, f;
  const r = Pe(e.analysisType), t = It(e.subtype, r, {
    ...e.raw
  }), s = Gs(t), a = Qs(
    e.conceptSets || []
  ), i = St(
    e.definition.criteriaGroups || [],
    r,
    e.definition.distributeBy
  ), l = r === _.DISTRIBUTION ? i.flatMap(
    (h) => tn(
      h,
      a
    )
  ) : i.map(
    (h) => Or(
      h,
      a
    )
  ), u = (e.conceptSets || []).map(ln).filter(Boolean), d = t === N.CUSTOM_SQL ? _.PREVALENCE : r, c = {
    ...e.raw,
    id: e.id === br ? void 0 : e.id,
    name: (x = e.name) == null ? void 0 : x.trim(),
    description: e.description || "",
    domain: e.domain || "",
    type: s,
    analysisType: r,
    statType: d,
    subtype: t,
    featureSubtype: t,
    definition: {
      ...((f = e.raw) == null ? void 0 : f.definition) || {},
      criteriaGroups: [],
      sql: "",
      distributeBy: ""
    },
    design: null,
    conceptSets: []
  };
  return s === me.CUSTOM_FE ? (c.design = e.definition.sql || "", c.definition.sql = e.definition.sql || "", c.sql = e.definition.sql || "", c.definition.criteriaGroups = [], c.criteriaGroups = [], c.conceptSets = null, c.distributeBy = "") : (c.design = l, c.definition.criteriaGroups = l, c.criteriaGroups = l, c.definition.distributeBy = void 0, c.distributeBy = void 0, c.definition.sql = "", c.sql = "", c.conceptSets = u), c;
}, er = (e, r) => JSON.stringify(e) === JSON.stringify(r), un = (e, r) => {
  const t = Ce(e), s = Ce(r), a = {};
  [
    "name",
    "description",
    "domain",
    "type",
    "analysisType",
    "statType",
    "subtype",
    "featureSubtype"
  ].forEach((l) => {
    er(t[l], s[l]) || (a[l] = s[l]);
  }), er(t.design, s.design) || (a.design = s.design);
  const i = !er(
    t.conceptSets,
    s.conceptSets
  );
  return i && Array.isArray(s.design) && (a.design = s.design), (i || Array.isArray(a.design)) && (a.conceptSets = s.conceptSets), Array.isArray(a.design) && (a.definition = {
    ...s.definition || {},
    criteriaGroups: a.design
  }, a.criteriaGroups = a.design), a;
}, Sr = (e) => {
  const r = ye(e), t = F(e == null ? void 0 : e.statType), s = t ? Pe(t) : r.analysisType, a = !!F((e == null ? void 0 : e.statType) || (e == null ? void 0 : e.analysisType));
  switch (s) {
    case _.DISTRIBUTION:
      return "Distribution";
    case _.CUSTOM:
      return "Custom";
    case _.PREVALENCE:
    default:
      return r.subtype === N.PRESET && !a ? "Preset" : "Prevalence";
  }
}, jt = (e) => {
  switch (ye(e).subtype) {
    case N.CRITERIA_SET:
      return "Criteria Set";
    case N.CUSTOM_SQL:
      return "Custom SQL";
    case N.PRESET:
    default:
      return "Preset";
  }
}, Dt = (e) => e.analysisType !== _.CUSTOM && e.subtype === N.CRITERIA_SET, cn = (e) => e.analysisType === _.CUSTOM || e.subtype === N.CUSTOM_SQL, dn = (e) => Dt(e) && !cn(e), or = (e, r) => {
  const t = r === _.CUSTOM ? N.CUSTOM_SQL : e.subtype === N.CUSTOM_SQL ? N.CRITERIA_SET : e.subtype, s = Ir[r];
  return {
    ...e,
    analysisType: r,
    subtype: s.allowedSubtypes.includes(t) ? t : s.allowedSubtypes[0],
    definition: {
      ...e.definition,
      distributeBy: s.supportsDistributeBy ? e.definition.distributeBy || s.defaultDistributeBy : "",
      criteriaGroups: s.supportsCriteria ? e.definition.criteriaGroups || [] : [],
      sql: s.supportsSql && e.definition.sql || ""
    },
    conceptSets: s.supportsCriteria ? e.conceptSets || [] : []
  };
}, pn = (e) => {
  var r;
  return Dt(e) ? Array.isArray((r = e.definition) == null ? void 0 : r.criteriaGroups) ? e.definition.criteriaGroups.length === 0 ? "Criteria definition has no criteria groups." : null : "Criteria definition is missing." : null;
}, yn = (e) => {
  const r = ye(e), t = pn(r);
  return { feature: r, error: t };
}, fe = "/draft-features", mn = "prometheus:custom-features-changed", Ut = () => {
  typeof window < "u" && window.dispatchEvent(new Event(mn));
}, fn = (e, r) => {
  const { pageNumber: t, pageSize: s, sortBy: a, query: i } = r, l = gr(a);
  return `${e}?size=${s ?? ""}&page=${t ?? 0}&sort=${l}&${i || ""}`;
}, En = (e, r) => {
  if (typeof e == "string")
    return e;
  if (e && typeof e == "object" && "id" in e && typeof e.id == "string")
    return e.id;
  throw new Error("Unable to resolve saved draft feature id");
}, Be = (e) => q.get(
  fn(`${fe}/list`, e)
), lr = (e) => q.get(
  `${fe}/filter?${e}`
), wt = () => q.get(`${fe}/sorts`), Ve = (e) => q.get(`${fe}/${e}`), Cn = (e, r) => q.post(
  `${fe}/concept-sets/copy/${e}`,
  r ? { name: r } : {}
), Mt = async (e) => {
  const r = await q.post(fe, e), t = En(r), s = await Ve(t);
  return Ut(), s;
}, hn = async (e, r) => (await q.patch(`${fe}/${e}`, r), Ve(e)), Ft = (e, r) => r !== "new" ? hn(r, e) : Mt(e), Lt = async (e) => {
  await q.delete(`${fe}/${e}`), Ut();
}, Tn = async () => {
  var e;
  try {
    return await Be({
      pageNumber: 0,
      pageSize: 1,
      sortBy: { id: "modified.timestamp", desc: !0 },
      query: ""
    }), !0;
  } catch (r) {
    return ![400, 403, 404, 405].includes((e = r == null ? void 0 : r.response) == null ? void 0 : e.status);
  }
}, xn = (e) => {
  const { draftFeatureId: r, message: t = "" } = e;
  if (!r)
    throw new Error("draft feature id is required for publish request");
  return q.post(`${fe}/${r}/publish`, {
    message: t
  });
}, Nr = "/library/feature-analyses", gn = [
  "/feature-analyses",
  "/feature-analysis",
  "/library/feature-analyses",
  "/library/feature-analysis"
], An = (e, r) => {
  const { pageNumber: t, pageSize: s, sortBy: a, query: i } = r, l = gr(a);
  return `${e}?size=${s ?? ""}&page=${t ?? 0}&sort=${l}&${i || ""}`;
}, Rn = async (e) => {
  var t;
  let r = null;
  for (const s of e)
    try {
      return await q.get(s);
    } catch (a) {
      r = a;
      const i = (t = a == null ? void 0 : a.response) == null ? void 0 : t.status;
      if (![400, 403, 404, 405].includes(i))
        throw a;
    }
  throw r;
}, Ye = (e) => q.get(
  An(`${Nr}/list`, e)
), Pt = (e) => q.get(
  `${Nr}/filter?${e}`
), Bt = () => q.get(
  `${Nr}/sorts`
), jr = (e) => Rn(
  gn.map((r) => `${r}/${e}`)
), In = async (e) => {
  var r;
  try {
    return await Ve(e);
  } catch (t) {
    const s = (r = t == null ? void 0 : t.response) == null ? void 0 : r.status;
    if (![403, 404, 405].includes(s))
      throw t;
    return jr(e);
  }
}, Vt = {
  workspace: "/workspace/feature-analyses/copy",
  study: (e) => `/studies/${e}/feature-analyses/copy`
}, bn = (e, r) => {
  const { pageNumber: t, pageSize: s, sortBy: a, query: i } = r, l = gr(a);
  return `${e}?size=${s ?? ""}&page=${t ?? 0}&sort=${l}&${i || ""}`;
}, kt = (e, r) => q.get(bn(e, r)), Gt = (e, r) => q.get(`${e}/filter?${r}`), _n = (e) => q.get(`${e}/sorts`), $t = (e) => kt(
  "/workspace/feature-analyses/list",
  e
), Yt = (e, r) => kt(
  `/studies/${e}/feature-analyses/list`,
  r
), On = (e) => Be(e), zt = (e) => Gt("/workspace/feature-analyses", e), Wt = (e, r) => Gt(`/studies/${r}/feature-analyses`, e), qt = () => _n("/workspace/feature-analyses"), Ht = (e) => q.get(`/conceptset/version/${e}`), vn = (e) => q.get(`/conceptset/${e}`), Qt = (e, r) => Ft(e, r), Sn = (e, r) => Qt(e, r), Nn = (e, r) => Qt(e, r), jn = (e) => {
  const r = e.featureAnalysisId || e.customFeatureId || e.featureId || e.analysisId;
  if (!r)
    throw new Error("feature id is required for publish request");
  return xn({
    draftFeatureId: r,
    message: e.message || ""
  });
}, Xt = (e) => {
  if (e && typeof e == "object" && "id" in e)
    return e;
  if (typeof e == "string")
    return { id: e };
}, kr = async (e, r, t = xr.CREATE_NEW_OBJECT) => Xt(
  await q.post(
    `${Vt.workspace}/${e}?resolution=${encodeURIComponent(t)}`,
    r ? { name: r } : {}
  )
), Dn = async (e, r, t, s = xr.CREATE_NEW_OBJECT) => Xt(
  await q.post(
    `${Vt.study(
      e
    )}/${r}?resolution=${encodeURIComponent(s)}`,
    t ? { name: t } : {}
  )
), Un = (e, r) => (t, s, a = xr.COPY) => {
  switch (e) {
    case ne.STUDY:
      return Dn(r, t, s, a);
    case ne.WORKSPACE:
      return kr(t, s, a);
    default:
      return kr(t, s, a);
  }
}, wn = (e, r, t, s) => e.values[t] > r.values[t] ? 1 : r.values[t] > e.values[t] ? -1 : 0, Mn = {
  createCols: (e, r, t) => [
    {
      Header: "",
      accessor: "typeEntity",
      id: "typeEntityIcon",
      disableSortBy: !0,
      width: "3%",
      minWidth: 45,
      Cell: () => /* @__PURE__ */ n.jsx(Xe, { value: Je.ANALYSIS, cell: !0, size: 28 })
    },
    mr(),
    fr({
      sortType: wn,
      Cell: (s) => {
        var a, i, l, u;
        return /* @__PURE__ */ n.jsx(
          dr,
          {
            text: (i = (a = s.row) == null ? void 0 : a.original) == null ? void 0 : i.description,
            color: "primary",
            width: "auto",
            children: /* @__PURE__ */ n.jsx("div", { children: /* @__PURE__ */ n.jsx(Tr, { value: (u = (l = s.row) == null ? void 0 : l.original) == null ? void 0 : u.name }) })
          }
        );
      }
    }),
    {
      Header: "Domain",
      accessor: (s) => ye(s).domain || "-",
      id: "domain"
    },
    {
      Header: "Type",
      accessor: (s) => Sr(s),
      id: "type"
    },
    {
      Header: "Subtype",
      accessor: (s) => jt(s),
      id: "subtype"
    },
    Er(),
    Cr(),
    hr(),
    ...t ? [] : [
      {
        Header: "",
        accessor: "actions",
        isCropped: !0,
        maxWidth: 100,
        disableSortBy: !0,
        Cell: (s) => /* @__PURE__ */ n.jsx(
          Jr,
          {
            onRemove: () => r(
              s.row.original.id || s.row.original.value
            )
          }
        )
      }
    ]
  ]
}, Fn = (e) => e === z.CUSTOM_FEATURE_STORE ? Be : Ye, Ln = (e) => e === z.CUSTOM_FEATURE_STORE ? lr : Pt, Pn = (e) => e === z.CUSTOM_FEATURE_STORE ? wt : Bt, Bn = {
  loadingMessage: "Loading custom features...",
  createCrudMethod: (e, r, t = z.ARTIFACTS_LIBRARY) => ({
    fetch: (s, a, i, l) => {
      const u = Fn(t);
      if (t === z.CUSTOM_FEATURE_STORE)
        return u({
          pageNumber: s,
          pageSize: a,
          sortBy: i,
          query: l
        });
      switch (e) {
        case ne.STUDY:
          return Yt(r, {
            pageNumber: s,
            pageSize: a,
            sortBy: i,
            query: l
          });
        case ne.WORKSPACE:
          return $t({
            pageNumber: s,
            pageSize: a,
            sortBy: i,
            query: l
          });
        default:
          return u({
            pageNumber: s,
            pageSize: a,
            sortBy: i,
            query: l
          });
      }
    }
  }),
  createFiltersPanel: (e, r, t = z.ARTIFACTS_LIBRARY) => {
    const s = Ln(t);
    return t === z.CUSTOM_FEATURE_STORE ? We(
      e,
      r,
      s
    ) : We(
      e,
      r,
      s,
      Wt,
      zt,
      s
    );
  },
  createSortingMethod(e, r = z.ARTIFACTS_LIBRARY) {
    const t = Pn(r);
    return Ar(e, {
      getSorting: t,
      getSortingWorkspace: qt
    });
  },
  cols: [
    Kr({
      Header: "",
      accessorFn: () => Je.ANALYSIS,
      id: "typeEntityIcon",
      width: "2%",
      cell: Xe
    }),
    mr(),
    fr({
      width: "20%",
      cell: (e) => {
        var r, t, s, a;
        return /* @__PURE__ */ n.jsx(
          dr,
          {
            text: (t = (r = e.row) == null ? void 0 : r.original) == null ? void 0 : t.description,
            color: "primary",
            width: "auto",
            children: /* @__PURE__ */ n.jsx("div", { children: /* @__PURE__ */ n.jsx(Tr, { value: (a = (s = e.row) == null ? void 0 : s.original) == null ? void 0 : a.name }) })
          }
        );
      }
    }),
    {
      header: "Domain",
      accessorFn: (e) => ye(e).domain || "-",
      id: "domain"
    },
    {
      header: "Type",
      accessorFn: (e) => Sr(e),
      id: "type"
    },
    {
      header: "Subtype",
      accessorFn: (e) => jt(e),
      id: "subtype"
    },
    Er(),
    Cr(),
    hr()
  ]
}, Vn = (e) => {
  const {
    onChange: r,
    typeContainer: t,
    parentId: s,
    isSelect: a,
    source: i = z.ARTIFACTS_LIBRARY,
    customStoreApiAvailable: l = !0,
    customStoreApiChecked: u = !0,
    showTitle: d = !0
  } = e, {
    createCrudMethod: c,
    createFiltersPanel: x,
    createSortingMethod: f,
    cols: h,
    loadingMessage: S
  } = Bn, E = i === z.CUSTOM_FEATURE_STORE && u && !l, j = i === z.CUSTOM_FEATURE_STORE && !u, L = te(
    () => ({
      fetch: async () => ({
        content: [],
        pageable: {
          offset: 0,
          pageNumber: 0,
          pageSize: 10,
          paged: !0,
          unpaged: !1,
          sort: { empty: !0, sorted: !1, unsorted: !0 }
        },
        empty: !0,
        first: !0,
        last: !0,
        number: 0,
        numberOfElements: 0,
        size: 10,
        sort: { empty: !0, sorted: !1, unsorted: !0 },
        totalElements: 0,
        totalPages: 1
      })
    }),
    []
  ), T = te(() => E || j ? L : c(t, s, i), [
    c,
    L,
    j,
    E,
    s,
    i,
    t
  ]), A = ze.useMemo(() => E || j ? {
    getFilters: async () => ({ items: [] })
  } : x(t, s, i), [
    x,
    j,
    E,
    s,
    i,
    t
  ]), C = ze.useMemo(() => E || j ? async () => [] : f == null ? void 0 : f(t, i), [
    f,
    j,
    E,
    s,
    i,
    t
  ]), { selectedConcepts: m, detectSelectedAction: D, clear: $ } = as(
    {},
    "id"
  ), {
    data: { tableData: Q, filtersData: V },
    filters: U,
    pageCount: Z,
    pageSize: R,
    isLoading: b,
    getEntity: ee,
    totalElements: J,
    updateFilters: Y,
    allowedSorting: ie,
    status: oe
  } = is(
    {
      get: T.fetch,
      remove: () => {
      },
      getFilters: A.getFilters,
      getSorting: C
    },
    "",
    !1
  ), P = te(
    () => _s(h, ie),
    [ie, h]
  ), k = (B) => {
    r(
      a ? Object.values(m).map((X) => ({
        ...X,
        source: i
      })) : [{ ...B.original, source: i }]
    );
  }, o = he((B, X) => {
    const le = {};
    B == null || B.forEach((ae) => {
      le[ae.id] = ae;
    }), D(le, X);
  }, []), g = Object.keys(m).length, { otherFilters: w, searchFilter: O } = Os(V);
  return /* @__PURE__ */ n.jsx(y, { container: !0, children: /* @__PURE__ */ n.jsxs(pr, { elevated: !0, outlined: !0, children: [
    d && /* @__PURE__ */ n.jsx(
      us,
      {
        title: i === z.CUSTOM_FEATURE_STORE ? "Custom Features Store" : "Artifacts Library",
        startIcon: /* @__PURE__ */ n.jsx(pe, { iconName: "list" })
      }
    ),
    /* @__PURE__ */ n.jsxs(
      y,
      {
        container: !0,
        className: "table-list-features-widget",
        pb: g ? 4 : 0,
        children: [
          /* @__PURE__ */ n.jsx(
            fs,
            {
              onAdd: () => {
                k();
              },
              onClear: $,
              selectedConceptsCount: g,
              buttonText: "Add feature to analysis",
              width: g != null ? "calc(100% - 250px)" : window.innerWidth - 250 + "px"
            }
          ),
          /* @__PURE__ */ n.jsxs(y, { item: !0, xs: 12, p: 2, children: [
            j && /* @__PURE__ */ n.jsxs(y, { item: !0, xs: 12, py: 4, textAlign: "center", children: [
              /* @__PURE__ */ n.jsx(pe, { iconName: "list", sx: { mb: 1, fontSize: 28 } }),
              /* @__PURE__ */ n.jsx("div", { children: "Checking Custom Features Store availability..." })
            ] }),
            E && /* @__PURE__ */ n.jsxs(y, { item: !0, xs: 12, py: 4, textAlign: "center", children: [
              /* @__PURE__ */ n.jsx(pe, { iconName: "info", sx: { mb: 1, fontSize: 28 } }),
              /* @__PURE__ */ n.jsx("div", { children: "Custom Features Store UI is ready, but backend API is not available yet." }),
              /* @__PURE__ */ n.jsxs("div", { children: [
                "Required endpoints: GET /api/draft-features/list, GET /api/draft-features/filter, GET /api/draft-features/sorts, GET /api/draft-features/",
                "{id}",
                ", POST /api/draft-features/concept-sets/copy/",
                "{id}",
                "."
              ] })
            ] }),
            !j && !E && /* @__PURE__ */ n.jsx(
              cs,
              {
                enableRowSelection: a,
                variant: "controlled",
                noDataText: "No data currently available",
                data: Q,
                columns: P,
                pageCount: Z,
                pageSize: R,
                loading: b,
                loadingMessage: S,
                fetchData: ee,
                totalElements: J,
                selectedRowIds: m,
                onRowSelect: o,
                onRowClick: a ? () => {
                } : k,
                getRowId: (B) => String(B.id),
                showFilterToggle: !0,
                searchComponent: O && /* @__PURE__ */ n.jsx(
                  ps,
                  {
                    ...O,
                    value: U == null ? void 0 : U[O == null ? void 0 : O.name],
                    onChange: (B) => Y({ [O == null ? void 0 : O.name]: B })
                  }
                ),
                children: /* @__PURE__ */ n.jsx(
                  ds,
                  {
                    showLabel: !0,
                    filters: w,
                    value: U,
                    onChange: (B, X) => Y({ [B]: X }),
                    isLoading: oe === re.IN_PROGRESS,
                    isReloading: oe === re.IN_PROGRESS_RELOAD
                  }
                )
              }
            )
          ] })
        ]
      }
    )
  ] }) });
};
var ce = /* @__PURE__ */ ((e) => (e.GET_COHORTS = "GET_COHORTS", e.SET_COHORTS = "SET_COHORTS", e.REMOVE_COHORT = "REMOVE_COHORT", e.CREATE_COHORT_REQUEST = "CREATE_COHORTS_REQUEST", e.CREATE_COHORT_REQUEST_DONE = "CREATE_COHORTS_REQUEST_DONE", e.CLEAR = "CLEAR", e))(ce || {});
const kn = {
  isCreated: !1,
  isUpdate: !1,
  isLoading: !1,
  features: {}
}, Gn = (e, r) => vs(e, (t) => {
  switch (r.type) {
    case ce.GET_COHORTS:
      t.features = r.payload;
      break;
    case ce.CREATE_COHORT_REQUEST:
      t.isCreated = !1, t.isUpdate = !1, t.isLoading = !0;
      break;
    case ce.CREATE_COHORT_REQUEST_DONE:
      t.isCreated = !0, t.isLoading = !1;
      break;
    case ce.CLEAR:
      t.features = {};
      break;
    case ce.SET_COHORTS:
      t.features = r.payload;
      break;
    case ce.REMOVE_COHORT:
      delete t.features[r.payload];
      break;
  }
}), $n = () => {
  const [e, r] = ss(
    Gn,
    kn
  ), t = he(
    async (i) => {
      try {
        const l = [];
        i.forEach((c) => {
          l.push(In(c));
        });
        const u = await Promise.all(l), d = {};
        return u.forEach((c) => {
          const x = ye(c);
          d[c.id] = {
            value: c.id,
            id: c.id,
            name: x.name,
            description: x.description,
            domain: x.domain,
            analysisType: x.analysisType,
            subtype: x.subtype
          };
        }), r({
          type: ce.GET_COHORTS,
          payload: d
        }), d;
      } catch {
      }
    },
    [e.features]
  ), s = he((i, l) => {
    r({
      type: ce.SET_COHORTS,
      payload: i
    });
  }, []), a = he(async (i) => {
    r({
      type: ce.REMOVE_COHORT,
      payload: i
    });
  }, []);
  return {
    ...e,
    getExistFeatureById: t,
    setFeatureByImport: s,
    removeFeature: a
  };
}, Yn = [
  z.ARTIFACTS_LIBRARY,
  z.CUSTOM_FEATURE_STORE
], zn = (e) => {
  var r, t, s;
  return ((t = (r = e == null ? void 0 : e.response) == null ? void 0 : r.data) == null ? void 0 : t.message) || ((s = e == null ? void 0 : e.response) == null ? void 0 : s.statusText) || (e == null ? void 0 : e.message) || "Import failed";
}, Wn = ({
  isSelect: e,
  onChange: r,
  availableSources: t = Yn
}) => {
  const [s, a] = G("loading"), i = te(
    () => t.filter(
      (c) => c !== z.CUSTOM_FEATURE_STORE || s === "available"
    ),
    [t, s]
  ), [l, u] = G(
    z.ARTIFACTS_LIBRARY
  );
  de(() => {
    if (!t.includes(z.CUSTOM_FEATURE_STORE)) {
      a("unavailable");
      return;
    }
    let c = !0;
    return Tn().then((x) => {
      c && a(x ? "available" : "unavailable");
    }).catch(() => {
      c && a("unavailable");
    }), () => {
      c = !1;
    };
  }, [t]), de(() => {
    i.includes(l) || u(
      i[0] || z.ARTIFACTS_LIBRARY
    );
  }, [l, i]);
  const d = te(() => i.map((c) => ({
    value: c,
    title: c === z.CUSTOM_FEATURE_STORE ? "Custom Features Store" : "Artifacts Library",
    onTabClick: u
  })), [i]);
  return /* @__PURE__ */ n.jsxs(y, { container: !0, children: [
    d.length > 0 && /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(ys, { elevation: 3, sx: { zIndex: 2, px: 2, width: "100%" }, children: /* @__PURE__ */ n.jsx(
      Zr,
      {
        tabs: d,
        active: l
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(
      Vn,
      {
        source: l,
        isSelect: e,
        onChange: r,
        typeContainer: null,
        parentId: null,
        showTitle: !1,
        customStoreApiAvailable: s === "available",
        customStoreApiChecked: s !== "loading"
      }
    ) })
  ] });
}, qn = (e) => {
  var R;
  const {
    titleText: r,
    buttonText: t,
    onChange: s,
    initialData: a,
    isSelect: i,
    viewMode: l,
    classNameContainer: u = "feature-import-button",
    defaultState: d,
    availableSources: c,
    modalTitle: x
  } = e, { createCols: f } = Mn, { openModal: h, closeModal: S } = Te(cr), { enqueueSnackbar: E } = yr(), [j, L] = G(!1), [T, A] = G(!1), { getExistFeatureById: C, features: m, setFeatureByImport: D, removeFeature: $ } = $n(), Q = te(() => f(
    null,
    async (b) => {
      await $(b);
      const ee = { ...m };
      delete ee[b], s(Object.keys(ee));
    },
    l
  ), [m, s, $, l]), V = async (b) => {
    const J = (Array.isArray(b) ? b : []).filter(Boolean).filter(
      (P) => (P == null ? void 0 : P.id) && !Object.prototype.hasOwnProperty.call(m, P.id)
    );
    if (J.length === 0) {
      A(!1), S();
      return;
    }
    A(!0);
    const Y = [];
    for (const P of J)
      try {
        const k = (P == null ? void 0 : P.source) === z.CUSTOM_FEATURE_STORE ? await Ve(P.id) : await jr(P.id), { feature: o, error: g } = yn(k);
        if (g) {
          const w = o.name || P.name || "unknown", O = o.id || P.id;
          E({
            message: `Cannot import analysis, due to invalid Criteria set Feature analysis (id: ${O}, name: ${w}). ${g}`,
            variant: "error"
          });
          continue;
        }
        Y.push(o);
      } catch (k) {
        E({
          message: `${P.name || P.id}: ${zn(k)}`,
          variant: "error"
        });
      }
    const ie = Y.reduce((P, k) => (P[k.id] = {
      value: k.id,
      id: k.id,
      name: k.name,
      description: k.description,
      domain: k.domain,
      analysisType: k.analysisType,
      subtype: k.subtype
    }, P), {}), oe = { ...m, ...ie };
    D(oe, i), s(Object.keys(oe)), A(!1), S();
  }, U = () => {
    h(
      () => /* @__PURE__ */ n.jsx(y, { container: !0, p: 2, children: /* @__PURE__ */ n.jsx(
        Wn,
        {
          isSelect: i,
          onChange: V,
          availableSources: c
        }
      ) }),
      x || "Import custom features",
      {
        onClose: S,
        closeOnClickOutside: !0
      }
    );
  }, Z = (b) => {
    b == null || b.stopPropagation(), U();
  };
  return de(() => {
    if (a && a.length > 0) {
      L(!0);
      const b = [];
      Object.keys(m).forEach((J) => {
        a.includes(m[J].id) && b.push(m[J].id);
      });
      const ee = a.filter(
        (J) => !b.includes(J)
      );
      ee.length > 0 ? C(ee).finally(
        () => L(!1)
      ) : L(!1);
    } else
      L(!1);
  }, [m, C, a]), /* @__PURE__ */ n.jsx(
    Qr,
    {
      collapsible: !0,
      title: r,
      defaultState: d,
      elevated: !0,
      outlined: !0,
      actions: !l && /* @__PURE__ */ n.jsx(y, { item: !0, children: /* @__PURE__ */ n.jsx(
        Ae,
        {
          onClick: Z,
          variant: "contained",
          color: "info",
          startIcon: T ? /* @__PURE__ */ n.jsx(_e, { size: 16 }) : /* @__PURE__ */ n.jsx(pe, { iconName: "add" }),
          name: `button-${u}`,
          disabled: T,
          children: t
        }
      ) }),
      children: /* @__PURE__ */ n.jsxs(y, { container: !0, className: u, mt: -1, children: [
        Object.keys(m).length > 0 ? /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, className: `table-${u}`, children: /* @__PURE__ */ n.jsx(
          Xr,
          {
            columns: Q,
            data: Object.keys(m).map((b) => m[b]),
            totalElements: (R = Object.keys(m)) == null ? void 0 : R.length,
            isLoading: j,
            loadingMessage: "",
            enableSorting: !0,
            enablePagination: !0
          }
        ) }) : /* @__PURE__ */ n.jsx(
          y,
          {
            item: !0,
            xs: 12,
            sx: {
              backgroundColor: "backgroundColor.main",
              textAlign: "center",
              p: 1,
              mt: 1
            },
            children: /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", color: "borderColor.main", children: "No custom features" })
          }
        ),
        Object.keys(m).length === 0 && j && /* @__PURE__ */ n.jsx(ve, { children: /* @__PURE__ */ n.jsx(_e, { size: 32 }) })
      ] })
    }
  );
}, Hn = {
  createCols: (e, r, t) => {
    const s = [
      {
        Header: "Name",
        accessor: "name",
        id: "name"
      },
      {
        Header: "Value",
        accessor: "value",
        id: "value"
      }
    ];
    return t || s.push({
      Header: "",
      accessor: "actions",
      isCropped: !0,
      maxWidth: 100,
      disableSortBy: !0,
      Cell: (a) => /* @__PURE__ */ n.jsx(
        Jr,
        {
          onRemove: () => r(a.row.original.id)
        }
      )
    }), s;
  }
}, Gr = (e) => Array.isArray(e) ? e.reduce((r, t) => {
  const s = (t == null ? void 0 : t.id) || Rr();
  return r[s] = {
    id: s,
    ...t
  }, r;
}, {}) : e && typeof e == "object" ? e : {}, Qn = (e) => {
  const { onChange: r, initialParams: t, titleText: s, viewMode: a, defaultState: i } = e, { createCols: l } = Hn, [u, d] = G(() => Gr(t)), [c, x] = G(!1), f = ns(!1);
  de(() => {
    const T = Gr(t);
    d((A) => f.current ? (f.current = !1, Object.keys(A).reduce(
      (C, m) => {
        var Q, V, U, Z;
        const D = (V = (Q = A[m]) == null ? void 0 : Q.name) == null ? void 0 : V.trim(), $ = (Z = (U = A[m]) == null ? void 0 : U.value) == null ? void 0 : Z.trim();
        return !T[m] && (!D || !$) && (C[m] = A[m]), C;
      },
      { ...T }
    )) : T);
  }, [t]);
  const h = te(() => l(
    null,
    async (T) => {
      const A = { ...u };
      delete A[T], d(A), r(A);
    },
    a
  ), [u, a]), S = (T) => {
    f.current = !0, r(
      Object.keys(T).reduce((A, C) => {
        var $, Q, V, U;
        const m = (Q = ($ = T[C]) == null ? void 0 : $.name) == null ? void 0 : Q.trim(), D = (U = (V = T[C]) == null ? void 0 : V.value) == null ? void 0 : U.trim();
        return m && D && (A[C] = {
          ...T[C],
          name: m,
          value: D
        }), A;
      }, {})
    );
  }, E = (T) => {
    T == null || T.stopPropagation();
    const A = Rr();
    d({
      ...u,
      [A]: {
        id: A,
        name: "",
        value: ""
      }
    });
  }, j = (T, A, C) => {
    const m = {
      ...u,
      [T]: {
        ...u[T],
        [A]: C
      }
    };
    d(m), S(m);
  }, L = (T) => {
    const A = { ...u };
    delete A[T], d(A), S(A);
  };
  return /* @__PURE__ */ n.jsxs(
    Qr,
    {
      collapsible: !0,
      title: s || "Feature analyses parameters",
      defaultState: i,
      elevated: !0,
      outlined: !0,
      actions: !a && /* @__PURE__ */ n.jsx(y, { item: !0, children: /* @__PURE__ */ n.jsx(
        Ae,
        {
          onClick: E,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ n.jsx(pe, { iconName: "add", fontSize: "small" }),
          name: "save",
          children: "Add parameter"
        }
      ) }),
      children: [
        Object.keys(u).length > 0 && !a && /* @__PURE__ */ n.jsx(y, { container: !0, spacing: 1, children: Object.keys(u).map((T) => {
          var A, C;
          return /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsxs(y, { container: !0, spacing: 1, alignItems: "center", children: [
            /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, md: 4, children: /* @__PURE__ */ n.jsx(
              Oe,
              {
                name: `parameter-name-${T}`,
                type: "text",
                size: "medium",
                value: ((A = u[T]) == null ? void 0 : A.name) || "",
                placeholder: "@parameter_name",
                onChange: (m) => j(T, "name", m.target.value),
                fullWidth: !0
              }
            ) }),
            /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, md: 4, children: /* @__PURE__ */ n.jsx(
              Oe,
              {
                name: `parameter-value-${T}`,
                type: "text",
                size: "medium",
                value: ((C = u[T]) == null ? void 0 : C.value) || "",
                placeholder: "parameter_value",
                onChange: (m) => j(T, "value", m.target.value),
                fullWidth: !0
              }
            ) }),
            /* @__PURE__ */ n.jsx(y, { item: !0, children: /* @__PURE__ */ n.jsx(Es, { onRemove: () => L(T) }) })
          ] }) }, T);
        }) }),
        Object.keys(u).length > 0 && a && /* @__PURE__ */ n.jsx(y, { container: !0, children: /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, className: "table-features", children: /* @__PURE__ */ n.jsx(
          Xr,
          {
            columns: h,
            data: Object.keys(u).map((T) => u[T]),
            isLoading: c,
            loadingMessage: "",
            enableSorting: !0,
            enablePagination: !0,
            showColumnToggle: !0
          }
        ) }) }),
        Object.keys(u).length === 0 && c && /* @__PURE__ */ n.jsx(ve, { children: /* @__PURE__ */ n.jsx(_e, { size: 32 }) })
      ]
    }
  );
}, Xn = qr((e) => {
  const { name: r, config: t, ...s } = e, {
    typeContainer: a,
    parentId: i,
    multiple: l,
    fastMarker: u,
    values: d,
    viewMode: c,
    buttonText: x,
    titleText: f,
    contextConceptSets: h,
    initialData: S,
    isSelect: E,
    returnEntityText: j,
    onChange: L,
    initialParams: T,
    classNameContainer: A,
    defaultState: C,
    availableSources: m,
    modalTitle: D
  } = t;
  return /* @__PURE__ */ n.jsxs(ze.Fragment, { children: [
    r === "widget-feature-import-button" && /* @__PURE__ */ n.jsx(
      qn,
      {
        ...s,
        typeContainer: a,
        multiple: l,
        parentId: i,
        onChange: L,
        buttonText: x,
        titleText: f,
        initialData: S,
        isSelect: E,
        returnEntityText: j,
        classNameContainer: A,
        defaultState: C,
        availableSources: m,
        modalTitle: D
      }
    ),
    r === "widget-feature-params" && /* @__PURE__ */ n.jsx(
      Qn,
      {
        ...s,
        titleText: f,
        viewMode: c,
        onChange: L,
        initialParams: T
      }
    )
  ] });
}), Jn = {
  rowId: "id",
  loadingMessage: "Loading custom features...",
  addButtonTitle: "Add Custom Feature",
  tableTitle: "Custom Features",
  moduleDescription: /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    /* @__PURE__ */ n.jsx("strong", { children: "Feature Extraction" }),
    " is the process of generating descriptive statistics (covariates) for a specific population.",
    " ",
    /* @__PURE__ */ n.jsx("strong", { children: "Custom Features" }),
    " allow you to look beyond standard clinical characteristics to answer highly specific research questions about a cohort. You can define custom features using",
    " ",
    /* @__PURE__ */ n.jsx("strong", { children: "Criteria-based Features" }),
    " (Prevalence or Distribution type) or ",
    /* @__PURE__ */ n.jsx("strong", { children: "SQL-based Features" }),
    " (custom, parameterized SQL). Custom Features are used in ",
    /* @__PURE__ */ n.jsx("strong", { children: "Cohort Characterization" }),
    " analytics."
  ] }),
  importButtonTitle: "Import",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createCrudMethod: (e, r) => nt(
    e,
    r,
    Be,
    Lt,
    Yt,
    $t,
    Be
  ),
  cols: [
    Kr({
      Header: "",
      accessorFn: () => Je.ANALYSIS,
      id: "typeEntityIcon",
      width: "2%",
      cell: Xe
    }),
    mr(),
    fr({
      width: "26%",
      cell: (e) => {
        var r, t, s, a;
        return /* @__PURE__ */ n.jsx(
          dr,
          {
            text: (t = (r = e.row) == null ? void 0 : r.original) == null ? void 0 : t.description,
            color: "primary",
            width: "auto",
            children: /* @__PURE__ */ n.jsx("div", { children: /* @__PURE__ */ n.jsx(Tr, { value: (a = (s = e.row) == null ? void 0 : s.original) == null ? void 0 : a.name }) })
          }
        );
      }
    }),
    {
      header: "Domain",
      accessorFn: (e) => ye(e).domain || "-",
      id: "domain"
    },
    {
      header: "Type",
      accessorFn: (e) => Sr(e),
      id: "type",
      size: 150,
      minSize: 150,
      maxSize: 150,
      enableResizing: !1
    },
    Er(),
    Cr(),
    hr()
  ],
  createSortingMethod(e) {
    return Ar(e, {
      getSorting: wt,
      getSortingWorkspace: qt
    });
  },
  createFiltersPanel: (e, r) => We(
    e,
    r,
    lr,
    Wt,
    zt,
    lr
  )
}, Kn = qr(
  ({ onCancel: e, onSubmit: r }) => {
    const [t, s] = G({
      name: "",
      description: "",
      domain: "",
      analysisType: _.PREVALENCE
    }), [a, i] = G(!1), l = async () => {
      i(!0);
      try {
        await r({
          name: t.name.trim(),
          description: t.description,
          domain: t.domain,
          analysisType: t.analysisType
        });
      } finally {
        i(!1);
      }
    };
    return /* @__PURE__ */ n.jsx(y, { container: !0, p: 2, children: /* @__PURE__ */ n.jsx(pr, { elevated: !0, outlined: !0, children: /* @__PURE__ */ n.jsxs(y, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(Ie, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ n.jsx(
        Oe,
        {
          id: "name",
          name: "name",
          type: "text",
          size: "medium",
          value: t.name,
          placeholder: "Enter name",
          onChange: (u) => s((d) => ({
            ...d,
            name: u.target.value
          })),
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(Ie, { name: "description", textLabel: "Description", children: /* @__PURE__ */ n.jsx(
        Oe,
        {
          id: "description",
          name: "description",
          type: "text",
          size: "medium",
          value: t.description,
          placeholder: "Enter description",
          onChange: (u) => s((d) => ({
            ...d,
            description: u.target.value
          })),
          fullWidth: !0,
          multiline: !0,
          minRows: 2,
          maxRows: 10
        }
      ) }) }),
      /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, md: 6, children: /* @__PURE__ */ n.jsx(Ie, { name: "domain", textLabel: "Domain", required: !0, children: /* @__PURE__ */ n.jsx(
        Fe,
        {
          id: "domain",
          name: "domain",
          options: mt,
          value: t.domain,
          onChange: (u) => s((d) => ({
            ...d,
            domain: u
          })),
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, md: 6, children: /* @__PURE__ */ n.jsx(
        Ie,
        {
          name: "analysisType",
          textLabel: "Analysis type",
          required: !0,
          children: /* @__PURE__ */ n.jsx(
            Fe,
            {
              id: "analysisType",
              name: "analysisType",
              options: yt,
              value: t.analysisType,
              onChange: (u) => s((d) => ({
                ...d,
                analysisType: u
              })),
              fullWidth: !0
            }
          )
        }
      ) }),
      /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsxs(et, { children: [
        /* @__PURE__ */ n.jsx(
          Ae,
          {
            variant: "outlined",
            onClick: e,
            startIcon: /* @__PURE__ */ n.jsx(pe, { iconName: "deactivate" }),
            name: "cancel",
            disabled: a,
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ n.jsx(
          Ae,
          {
            disabled: !t.name.trim() || !t.domain || a,
            onClick: l,
            variant: "contained",
            color: "success",
            startIcon: /* @__PURE__ */ n.jsx(pe, { iconName: "submit" }),
            name: "save",
            children: "Continue"
          }
        )
      ] }) })
    ] }) }) });
  }
), Zn = () => {
  const e = lt(), { enqueueSnackbar: r } = yr(), { openModal: t, closeModal: s } = Te(cr), [a, i] = G(), l = Te(
    ke
  ), u = async (d) => {
    var c, x, f;
    try {
      const h = Me(), S = or(
        {
          ...h,
          name: d.name,
          description: d.description,
          domain: d.domain
        },
        d.analysisType
      ), E = await Mt(
        Ce(S)
      );
      if (!(E != null && E.id))
        throw new Error("Unable to resolve created custom feature id");
      i(Rr()), window.dispatchEvent(new Event("prometheus:close-modal")), e(`/${l.path}/${E.id}`, {
        replace: !0
      });
    } catch (h) {
      r({
        message: ((x = (c = h == null ? void 0 : h.response) == null ? void 0 : c.data) == null ? void 0 : x.message) || ((f = h == null ? void 0 : h.response) == null ? void 0 : f.statusText) || (h == null ? void 0 : h.message) || "Unable to create custom feature.",
        variant: "error"
      });
    }
  };
  return /* @__PURE__ */ n.jsx(
    rt,
    {
      isImport: !1,
      moduleConfig: l,
      listConfig: Jn,
      reloadId: a,
      allowDelete: !0,
      variant: "description",
      deleteSuccessMessage: (d) => `Feature analysis ${(d == null ? void 0 : d.name) || ""} is deleted`,
      onCreate: () => t(
        () => /* @__PURE__ */ n.jsx(
          Kn,
          {
            onCancel: s,
            onSubmit: u
          }
        ),
        "Add custom feature",
        {
          closeOnClickOutside: !0,
          width: "700px",
          onClose: s
        }
      )
    }
  );
}, ea = "New custom feature", $r = {
  createCrudEntity: (e, r) => it(
    e,
    r,
    Ve,
    Lt,
    Ft,
    Nn,
    Sn
  ),
  entityBreadcrumbs: (e, r, t, s) => at(ea, e, r, t)
}, ra = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i, ta = (e) => {
  var s, a, i;
  const r = (e == null ? void 0 : e.shortcut) ?? ((s = e == null ? void 0 : e.raw) == null ? void 0 : s.shortcut) ?? (e == null ? void 0 : e.displayId) ?? ((a = e == null ? void 0 : e.raw) == null ? void 0 : a.displayId) ?? (e == null ? void 0 : e.externalId) ?? ((i = e == null ? void 0 : e.raw) == null ? void 0 : i.externalId) ?? (e == null ? void 0 : e.id);
  if (!r || r === "new")
    return null;
  const t = String(r);
  return ra.test(t) ? null : t;
}, sa = ({
  feature: e,
  viewMode: r,
  canDelete: t,
  canPublish: s,
  canExport: a,
  additionalActions: i,
  disableSave: l,
  disablePublish: u,
  versionPreview: d,
  onVersionRevert: c,
  onNameChange: x,
  onDescriptionChange: f,
  onSave: h,
  onDelete: S,
  onPublish: E,
  onExport: j
}) => {
  var C;
  const L = Us(), T = (e == null ? void 0 : e.subtype) === N.CRITERIA_SET ? "Criteria Set" : (e == null ? void 0 : e.subtype) === N.CUSTOM_SQL ? "Custom SQL" : "Preset", A = ta(e);
  return /* @__PURE__ */ n.jsxs(y, { container: !0, pb: 1, pt: 2, spacing: 1, children: [
    /* @__PURE__ */ n.jsxs(y, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      /* @__PURE__ */ n.jsx(y, { item: !0, mr: 1.5, display: "flex", children: /* @__PURE__ */ n.jsx(Xe, { value: Je.ANALYSIS, size: 32 }) }),
      /* @__PURE__ */ n.jsx(y, { item: !0, flexGrow: 1, minWidth: 0, mr: 1, children: /* @__PURE__ */ n.jsx(
        Mr,
        {
          size: "medium",
          value: e == null ? void 0 : e.name,
          fullWidth: !0,
          color: L.palette.textColor.primary,
          onSubmit: (m) => x(m || ""),
          onValueChange: (m) => x(m || ""),
          disabled: r || d,
          name: "custom-feature-name",
          required: !0,
          showActions: !1
        }
      ) }),
      s && E && !d && /* @__PURE__ */ n.jsx(y, { item: !0, ml: 1, children: /* @__PURE__ */ n.jsx(
        Ae,
        {
          variant: "outlined",
          color: "primary",
          onClick: E,
          disabled: u,
          startIcon: /* @__PURE__ */ n.jsx(pe, { iconName: "publish" }),
          name: "custom-feature-publish",
          children: "Publish"
        }
      ) }),
      i && /* @__PURE__ */ n.jsx(y, { item: !0, ml: 1, className: "cohort-base-info__actions-additional", children: i }),
      !r && d ? /* @__PURE__ */ n.jsx(y, { item: !0, ml: 1, children: /* @__PURE__ */ n.jsx(
        $e,
        {
          color: "primary",
          iconName: "reload",
          onClick: c,
          tooltipText: "Back to current version",
          title: "Back to current version",
          name: "custom-feature-version-revert"
        }
      ) }) : /* @__PURE__ */ n.jsx(n.Fragment, { children: !r && /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
        t && /* @__PURE__ */ n.jsx(y, { item: !0, ml: 1, children: /* @__PURE__ */ n.jsx(
          $e,
          {
            color: "error",
            iconName: "delete",
            onClick: S,
            tooltipText: "Delete",
            title: "Delete",
            name: "custom-feature-delete",
            noExpand: !0
          }
        ) }),
        a && /* @__PURE__ */ n.jsx(y, { item: !0, ml: 1, children: /* @__PURE__ */ n.jsx(
          $e,
          {
            color: "primary",
            iconName: "export",
            onClick: j,
            tooltipText: "Export",
            title: "Export",
            name: "custom-feature-export"
          }
        ) }),
        /* @__PURE__ */ n.jsx(y, { item: !0, ml: 1, children: /* @__PURE__ */ n.jsx(
          $e,
          {
            color: "success",
            iconName: "save",
            disabled: l,
            tooltipText: "Save",
            title: "Save",
            name: "custom-feature-save",
            onClick: h
          }
        ) })
      ] }) })
    ] }),
    /* @__PURE__ */ n.jsxs(y, { item: !0, xs: 12, container: !0, columnSpacing: 2, children: [
      /* @__PURE__ */ n.jsxs(y, { item: !0, mr: 2, children: [
        /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Type:" }),
        /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", component: "span", fontWeight: 700, children: "Custom Feature" })
      ] }),
      A && /* @__PURE__ */ n.jsxs(y, { item: !0, mr: 2, children: [
        /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "ID:" }),
        /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", component: "span", fontWeight: 700, children: A })
      ] }),
      /* @__PURE__ */ n.jsxs(y, { item: !0, mr: 2, children: [
        /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Sub-type:" }),
        /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", component: "span", fontWeight: 700, children: T })
      ] }),
      (e == null ? void 0 : e.modified) && /* @__PURE__ */ n.jsxs(y, { item: !0, children: [
        /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Modified date:" }),
        /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", component: "span", fontWeight: 700, children: Ss(e.modified.timestamp) })
      ] }),
      ((C = e == null ? void 0 : e.created) == null ? void 0 : C.user) && /* @__PURE__ */ n.jsxs(y, { item: !0, children: [
        /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Author:" }),
        /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", component: "span", fontWeight: 700, children: e.created.user.name })
      ] })
    ] }),
    !(r && !(e != null && e.description)) && /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(
      Mr,
      {
        value: e == null ? void 0 : e.description,
        onSubmit: (m) => f(m || ""),
        onValueChange: (m) => f(m || ""),
        color: L.palette.textColor.secondary,
        multiline: !0,
        fullWidth: !0,
        placeholder: r ? "..." : "Add description...",
        disabled: r || d,
        name: "custom-feature-description",
        showActions: !1,
        sx: {
          ml: -1,
          width: "calc(100% + 16px)"
        }
      }
    ) })
  ] });
}, Jt = ({ feature: e, viewMode: r, onDomainChange: t, onAnalysisTypeChange: s }) => /* @__PURE__ */ n.jsxs(
  ue,
  {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 3,
    sx: {
      bgcolor: "common.white",
      boxSizing: "border-box",
      py: 1,
      width: "100%"
    },
    children: [
      /* @__PURE__ */ n.jsxs(ue, { display: "flex", alignItems: "center", gap: 1.25, children: [
        /* @__PURE__ */ n.jsxs(
          W,
          {
            component: "label",
            variant: "subtitle2",
            htmlFor: "custom-feature-domain",
            fontWeight: 700,
            whiteSpace: "nowrap",
            sx: { ".required": { color: "error.main" } },
            children: [
              "Domain",
              /* @__PURE__ */ n.jsx("span", { className: "required", children: "*" })
            ]
          }
        ),
        /* @__PURE__ */ n.jsx(ue, { width: 180, children: /* @__PURE__ */ n.jsx(
          Fe,
          {
            id: "custom-feature-domain",
            name: "custom-feature-domain",
            options: mt,
            value: e.domain,
            onChange: t,
            disabled: r,
            fullWidth: !0
          }
        ) })
      ] }),
      /* @__PURE__ */ n.jsxs(ue, { display: "flex", alignItems: "center", gap: 1.25, children: [
        /* @__PURE__ */ n.jsxs(
          W,
          {
            component: "label",
            variant: "subtitle2",
            htmlFor: "custom-feature-analysis-type",
            fontWeight: 700,
            whiteSpace: "nowrap",
            sx: { ".required": { color: "error.main" } },
            children: [
              "Analysis type",
              /* @__PURE__ */ n.jsx("span", { className: "required", children: "*" })
            ]
          }
        ),
        /* @__PURE__ */ n.jsx(ue, { width: 180, children: /* @__PURE__ */ n.jsx(
          Fe,
          {
            id: "custom-feature-analysis-type",
            name: "custom-feature-analysis-type",
            options: yt,
            value: e.analysisType,
            onChange: s,
            disabled: r,
            fullWidth: !0
          }
        ) })
      ] })
    ]
  }
), Kt = ({
  feature: e,
  subModules: r,
  typeContainer: t,
  parentId: s,
  viewMode: a,
  hideControls: i,
  onDomainChange: l,
  onAnalysisTypeChange: u,
  onCriteriaGroupsChange: d,
  onConceptSetsChange: c,
  onSqlChange: x
}) => {
  var A;
  const f = te(
    () => Ir[e.analysisType],
    [e.analysisType]
  ), h = f.supportsCriteria, S = f.supportsSql, E = f.supportsDistributeBy && h, j = ((A = e.definition) == null ? void 0 : A.criteriaGroups) || [], L = h && !a && !j.length, T = he(
    ({ section: C, sectionId: m, updateSection: D }) => {
      if (!E || !Et(C))
        return null;
      const $ = Ct(C), V = $.map((U) => U.value).includes(C.distributeBy) ? C.distributeBy : K.EVENTS_COUNT;
      return /* @__PURE__ */ n.jsx(y, { container: !0, py: 1, children: /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, md: 6, children: /* @__PURE__ */ n.jsx(
        Cs,
        {
          name: `distributionField-${m}`,
          htmlFor: `custom-feature-distribution-by-${m}`,
          textLabel: "Distribute by field value",
          required: !0,
          dense: !0,
          fullSize: !0,
          children: /* @__PURE__ */ n.jsx(
            Fe,
            {
              id: `custom-feature-distribution-by-${m}`,
              name: `custom-feature-distribution-by-${m}`,
              options: $,
              value: V,
              onChange: (U) => D(m, "distributeBy", U),
              disabled: a
            }
          )
        }
      ) }) });
    },
    [E, a]
  );
  return /* @__PURE__ */ n.jsxs(ue, { sx: { bgcolor: "common.white", width: "100%" }, children: [
    !i && /* @__PURE__ */ n.jsx(
      Jt,
      {
        feature: e,
        viewMode: a,
        onDomainChange: l,
        onAnalysisTypeChange: u
      }
    ),
    h && /* @__PURE__ */ n.jsx(ue, { sx: { mt: 1, width: "100%" }, children: /* @__PURE__ */ n.jsx(
      r.cohort,
      {
        type: "component",
        name: "widget-criteria-group",
        subModules: r,
        config: {
          onChange: d,
          typeContainer: t,
          parentId: s,
          values: j,
          buttonText: "New criteria group",
          titleText: "",
          hiddenParentConcept: !0,
          hideIgnoreObservationPeriod: !0,
          useCohortSectionButtons: !0,
          hideCriteriaGroupHeader: !0,
          hideTopLevelCriteriaControls: e.analysisType === _.DISTRIBUTION,
          criteriaButtonsSx: {
            py: 0
          },
          criteriaSectionsSx: {
            bgcolor: "backgroundColor.dark",
            p: 1,
            mt: a ? 0 : 1,
            boxSizing: "border-box",
            rowGap: 1,
            minHeight: 32,
            alignItems: "center",
            ...L ? {
              "&::before": {
                content: '"Add Criteria Feature using Demographics, Health System, Clinical Events or Health Economics"',
                color: "text.secondary",
                display: "block",
                fontSize: 14,
                lineHeight: "20px",
                textAlign: "center",
                width: "100%"
              }
            } : {}
          },
          hideOccurrence: e.analysisType === _.DISTRIBUTION,
          renderSectionContentBeforeCriteria: T,
          contextConceptSets: {
            conceptSets: e.conceptSets || [],
            updateConceptSets: c,
            embeddedReferenceOnly: !0
          },
          viewMode: a
        }
      }
    ) }),
    !h && !S && /* @__PURE__ */ n.jsx(ue, { children: /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", color: "text.secondary", children: "Preset subtype does not require criteria definition." }) }),
    S && /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
      /* @__PURE__ */ n.jsxs(ue, { sx: { mt: 1 }, children: [
        /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", sx: { mb: 1 }, children: "Analysis SQL:" }),
        /* @__PURE__ */ n.jsx(
          W,
          {
            component: "pre",
            variant: "body2",
            sx: {
              fontFamily: "monospace",
              mb: 0.5,
              overflowX: "auto",
              whiteSpace: "pre"
            },
            children: `SELECT covariate_id, covariate_name, concept_id, sum_value, average_value
FROM (`
          }
        ),
        /* @__PURE__ */ n.jsx(
          hs,
          {
            data: e.definition.sql || "",
            language: "sql",
            placeholder: Ys,
            readOnly: a,
            enableValidation: !1,
            enableDownload: !1,
            editorOptions: {
              wordWrap: "on",
              wrappingIndent: "same",
              wrappingStrategy: "advanced",
              scrollbar: {
                horizontal: "hidden"
              }
            },
            placeholderStyles: {
              bottom: 0,
              overflow: "hidden",
              overflowWrap: "anywhere",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word"
            },
            onChange: (C) => x(C || ""),
            height: "520px"
          }
        ),
        /* @__PURE__ */ n.jsx(
          W,
          {
            component: "pre",
            variant: "body2",
            sx: {
              fontFamily: "monospace",
              mt: 0.5,
              whiteSpace: "pre"
            },
            children: ")"
          }
        )
      ] }),
      /* @__PURE__ */ n.jsxs(ue, { sx: { mt: 2 }, children: [
        /* @__PURE__ */ n.jsx(W, { variant: "subtitle2", sx: { mb: 1 }, children: "Available variables:" }),
        /* @__PURE__ */ n.jsx(ue, { component: "ul", sx: { m: 0, pl: 3 }, children: $s.map((C) => /* @__PURE__ */ n.jsx(
          W,
          {
            component: "li",
            variant: "body2",
            color: "text.secondary",
            children: C
          },
          C
        )) })
      ] })
    ] })
  ] });
}, rr = (e) => {
  var r, t, s;
  return ((t = (r = e == null ? void 0 : e.response) == null ? void 0 : r.data) == null ? void 0 : t.message) || ((s = e == null ? void 0 : e.response) == null ? void 0 : s.statusText) || (e == null ? void 0 : e.message) || "Something went wrong";
}, na = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i, Dr = (e) => typeof e == "string" && na.test(e), ur = (e) => {
  if (typeof e == "number" && Number.isFinite(e))
    return String(e);
  if (typeof e == "string") {
    const r = e.trim();
    return r || null;
  }
  return null;
}, Ue = (e) => typeof e == "object" && e !== null, aa = (e) => {
  var t;
  const r = (t = e == null ? void 0 : e.expression) == null ? void 0 : t.items;
  return Array.isArray(r) ? r.length : r && typeof r == "object" ? Object.keys(r).length : 0;
}, ia = (e) => e ? Array.isArray(e) ? e.map((r) => ({
  concept: (r == null ? void 0 : r.concept) || {},
  includeDescendants: (r == null ? void 0 : r.includeDescendants) ?? (r == null ? void 0 : r.descendants) ?? !1,
  includeMapped: (r == null ? void 0 : r.includeMapped) ?? (r == null ? void 0 : r.mapped) ?? !1,
  isExcluded: (r == null ? void 0 : r.isExcluded) ?? (r == null ? void 0 : r.excluded) ?? !1,
  hierarchy: (r == null ? void 0 : r.hierarchy) ?? !1,
  id: r == null ? void 0 : r.id
})) : Ns(e) : [], oa = (e, r) => r.reduce(
  (t, s) => Ue(t) ? t[s] : void 0,
  e
), la = (e) => Array.isArray(e) ? e.length > 0 : e && typeof e == "object" ? Object.keys(e).length > 0 : !1, ua = (e) => {
  const r = [
    ["items"],
    ["expression", "items"],
    ["conceptSet", "items"],
    ["conceptSet", "expression", "items"],
    ["conceptSetVersion", "items"],
    ["conceptSetVersion", "expression", "items"],
    ["version", "items"],
    ["version", "expression", "items"]
  ];
  for (const t of r) {
    const s = oa(e, t);
    if (la(s))
      return s;
  }
}, ca = (e) => {
  const r = Ue(e) && Ue(e.data) ? e.data : Ue(e) ? e : {}, t = Ue(r.conceptSet) ? r.conceptSet : r;
  return {
    name: typeof r.name == "string" ? r.name : typeof t.name == "string" ? t.name : void 0,
    items: ua(r),
    versionOrdinal: r.ordinal ?? r.versionOrdinal ?? r.version ?? t.ordinal ?? t.versionOrdinal ?? t.version
  };
}, da = async (e) => {
  const r = e == null ? void 0 : e.conceptSets;
  if (!Array.isArray(r) || r.length === 0)
    return e;
  const t = await Promise.all(
    r.map(async (s) => {
      if (aa(s) > 0 || !(s != null && s.versionId))
        return s;
      try {
        const a = await Ht(
          String(s.versionId)
        ), i = ca(a);
        return {
          ...s,
          name: i.name ?? s.name,
          expression: {
            ...s.expression,
            items: ia(i.items)
          },
          versionOrdinal: i.versionOrdinal ?? s.versionOrdinal,
          version: i.versionOrdinal ?? s.version
        };
      } catch {
        return s;
      }
    })
  );
  return {
    ...e,
    conceptSets: t
  };
}, Yr = () => typeof globalThis < "u" && globalThis.crypto && typeof globalThis.crypto.randomUUID == "function" ? globalThis.crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
  const r = Math.floor(Math.random() * 16);
  return (e === "x" ? r : r & 3 | 8).toString(16);
}), pa = (e) => ({
  id: (e == null ? void 0 : e.id) ?? null,
  name: (e == null ? void 0 : e.name) || "New Concept set",
  uuid: (e == null ? void 0 : e.uuid) || (Dr(e == null ? void 0 : e.id) ? e.id : void 0),
  expression: (e == null ? void 0 : e.expression) || { items: [] },
  versionId: e == null ? void 0 : e.versionId,
  version: e == null ? void 0 : e.version,
  versionOrdinal: (e == null ? void 0 : e.versionOrdinal) ?? (e == null ? void 0 : e.version),
  currentVersionId: (e == null ? void 0 : e.currentVersionId) ?? (e == null ? void 0 : e.versionId),
  currentVersionOrdinal: (e == null ? void 0 : e.currentVersionOrdinal) ?? (e == null ? void 0 : e.versionOrdinal) ?? (e == null ? void 0 : e.version),
  needsDraftFeatureStoreFork: !0
}), ya = (e = [], r, t) => {
  if (!r)
    return e;
  const s = /* @__PURE__ */ new Set();
  return [t == null ? void 0 : t.id, t == null ? void 0 : t.uuid, t == null ? void 0 : t.externalId, r.id].forEach(
    (a) => {
      const i = ur(a);
      i && s.add(i);
    }
  ), s.size === 0 ? e : e.map((a) => [
    a == null ? void 0 : a.uuid,
    a == null ? void 0 : a.referenceId,
    a == null ? void 0 : a.externalId,
    a == null ? void 0 : a.id
  ].map(ur).filter(Boolean).some((u) => s.has(u)) ? {
    ...a,
    name: r.name ?? (a == null ? void 0 : a.name),
    uuid: (a == null ? void 0 : a.uuid) || (Dr(r.id) ? String(r.id) : void 0),
    versionId: r.versionId ?? (a == null ? void 0 : a.versionId),
    version: r.version ?? (a == null ? void 0 : a.version),
    versionOrdinal: r.versionOrdinal ?? r.version ?? (a == null ? void 0 : a.versionOrdinal),
    currentVersionId: r.currentVersionId ?? r.versionId ?? (a == null ? void 0 : a.currentVersionId),
    currentVersionOrdinal: r.currentVersionOrdinal ?? r.versionOrdinal ?? r.version ?? (a == null ? void 0 : a.currentVersionOrdinal)
  } : a);
}, ma = async (e) => {
  const r = [
    e == null ? void 0 : e.referenceId,
    e == null ? void 0 : e.uuid,
    e == null ? void 0 : e.externalId,
    e == null ? void 0 : e.id
  ].map(ur).find(Boolean);
  if (!r)
    throw new Error(
      `Unable to fork concept set "${(e == null ? void 0 : e.name) || "unknown"}"`
    );
  await Cn(r, e == null ? void 0 : e.name);
}, fa = async (e) => {
  const r = (e == null ? void 0 : e.conceptSets) || [];
  !Array.isArray(r) || r.length === 0 || await Promise.all(
    r.map((t) => t != null && t.isNewImport ? ma(t) : Promise.resolve())
  );
}, Ea = (e, r) => {
  var a, i;
  const t = (r == null ? void 0 : r.conceptSets) || [], s = {
    ...e,
    definition: {
      ...e.definition,
      criteriaGroups: ((a = r == null ? void 0 : r.definition) == null ? void 0 : a.criteriaGroups) || ((i = e.definition) == null ? void 0 : i.criteriaGroups) || []
    }
  };
  return t.length === 0 ? s : {
    ...s,
    conceptSets: t
  };
}, Ca = ({
  onCancel: e,
  onSave: r
}) => {
  const [t, s] = G({
    name: "",
    description: ""
  });
  return /* @__PURE__ */ n.jsx(y, { container: !0, p: 2, children: /* @__PURE__ */ n.jsx(pr, { elevated: !0, outlined: !0, children: /* @__PURE__ */ n.jsxs(y, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(Ie, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ n.jsx(
      Oe,
      {
        id: "name",
        name: "name",
        type: "text",
        size: "medium",
        value: t.name,
        placeholder: "Enter name",
        onChange: (a) => s((i) => ({ ...i, name: a.target.value })),
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(Ie, { name: "description", textLabel: "Description", children: /* @__PURE__ */ n.jsx(
      Oe,
      {
        id: "description",
        name: "description",
        type: "text",
        size: "medium",
        value: t.description,
        placeholder: "Enter description",
        onChange: (a) => s((i) => ({ ...i, description: a.target.value })),
        fullWidth: !0,
        multiline: !0,
        minRows: 2,
        maxRows: 10
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(W, { variant: "body2", color: "text.secondary", children: "This concept set will be added locally to the custom feature and saved with the draft feature." }) }),
    /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsxs(et, { children: [
      /* @__PURE__ */ n.jsx(
        Ae,
        {
          variant: "outlined",
          onClick: e,
          startIcon: /* @__PURE__ */ n.jsx(pe, { iconName: "deactivate" }),
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ n.jsx(
        Ae,
        {
          disabled: !t.name.trim(),
          onClick: () => {
            const a = Yr(), i = Yr();
            r({
              id: a,
              uuid: a,
              referenceId: a,
              versionId: i,
              currentVersionId: i,
              version: 1,
              versionOrdinal: 1,
              currentVersionOrdinal: 1,
              name: t.name.trim(),
              description: t.description,
              expression: { items: [] }
            });
          },
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ n.jsx(pe, { iconName: "submit" }),
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}, ha = ({
  subModules: e,
  typeContainer: r,
  parentId: t,
  conceptSetId: s,
  conceptSetModulePath: a,
  onClose: i,
  onConceptSetSaved: l,
  storage: u,
  initStorage: d
}) => /* @__PURE__ */ n.jsx("div", { style: { width: "100%", height: "100vh", backgroundColor: "#fff" }, children: /* @__PURE__ */ n.jsx(
  e.concept,
  {
    type: "component",
    name: "concept-set-entity-embedded",
    path: a,
    title: "Concept sets",
    subModules: e,
    storage: u,
    initStorage: d,
    rootSettings: {
      rootPath: a,
      rootTitle: "Concept sets"
    },
    config: {
      typeContainer: r,
      parentId: t,
      conceptSetId: s,
      onCancel: i,
      saveOnlyActions: !0,
      onConceptSetEntitySaved: l
    }
  }
) }), Ta = (e) => {
  var t, s, a;
  const r = [];
  return (t = e.name) != null && t.trim() || r.push("Name is required."), (s = e.domain) != null && s.trim() || r.push("Domain is required."), e.analysisType || r.push("Analysis type is required."), e.subtype || r.push("Subtype is required."), e.analysisType === _.CUSTOM && !((a = e.definition.sql) != null && a.trim()) && r.push("SQL query is required for Custom SQL subtype."), e.subtype === N.CRITERIA_SET && [
    _.DISTRIBUTION,
    _.PREVALENCE
  ].includes(e.analysisType) && (!Array.isArray(e.definition.criteriaGroups) || e.definition.criteriaGroups.length === 0) && r.push(
    "At least one criteria group is required for criteria-based features."
  ), r;
}, zr = (e, r) => {
  const t = ot(e);
  return t && Object.keys(t).length > 0 ? t : r === "new" ? { create: !0, update: !0, delete: !1 } : { create: !0, update: !0, delete: !0 };
}, xa = () => {
  var Ur;
  const { id: e = "new" } = ut(), [r] = js(), t = Ds(), s = lt(), a = dt(), { enqueueSnackbar: i } = yr(), { showDialog: l, hideDialog: u } = Te(os), { openModal: d, closeModal: c } = Te(cr), {
    rootSettings: x,
    path: f,
    title: h,
    config: S,
    subModules: E,
    storage: j,
    initStorage: L
  } = Te(
    ke
  ), { rootPath: T, rootTitle: A } = x, { parentId: C, parentTitle: m, typeContainer: D } = S, $ = te(
    () => $r.createCrudEntity(D, C),
    [D, C]
  ), [Q, V] = G(re.INITIAL), [U, Z] = G(null), [R, b] = G(
    Me()
  ), [ee, J] = G(
    Me()
  ), [Y, ie] = G({}), [oe, P] = G(!1), [k, o] = G(!1), [g, w] = G(!0), [O] = G(
    () => {
      var p;
      return (p = t.state) == null ? void 0 : p.initialFeature;
    }
  ), B = !!(S.publishRequestPreview || r.get("from") && r.get("from") === ne.LIBRARY), X = async () => {
    var p, I;
    try {
      const v = await On({
        pageNumber: 0,
        pageSize: 1,
        sortBy: { id: "modified.timestamp", desc: !0 },
        query: ""
      }), M = (p = ot(v == null ? void 0 : v.actions)) == null ? void 0 : p.create;
      return M == null ? !0 : !!M;
    } catch (v) {
      const M = (I = v == null ? void 0 : v.response) == null ? void 0 : I.status;
      if ([401, 403].includes(M))
        return !1;
      throw v;
    }
  };
  de(() => {
    let p = !0;
    return (async () => {
      V(re.IN_PROGRESS), Z(null);
      try {
        if (e === "new") {
          if (!await X()) {
            if (!p)
              return;
            w(!1), V(re.ERROR), Z({
              response: {
                status: 403,
                statusText: "Forbidden",
                message: "You do not have permission to create custom features.",
                data: null
              }
            });
            return;
          }
          const Ke = Me(), wr = {
            ...Ke,
            name: (O == null ? void 0 : O.name) || Ke.name,
            description: (O == null ? void 0 : O.description) || Ke.description
          };
          p && (ie({ create: !0, update: !0, delete: !1 }), b(wr), J(wr), o(!1), V(re.SUCCESS));
          return;
        }
        const v = await $.getMethod(e), M = await da(
          ye(v)
        );
        p && (ie(zr(v == null ? void 0 : v.actions, e)), b(M), J(M), o(!1), V(re.SUCCESS));
      } catch (v) {
        p && (Z(v), V(re.ERROR));
      }
    })(), () => {
      p = !1;
    };
  }, [e, O, $.getMethod]), de(() => {
    const p = (R == null ? void 0 : R.name) || "New custom feature";
    a(
      pt(
        $r.entityBreadcrumbs(
          e,
          p,
          {
            path: f,
            title: h,
            rootPath: T,
            rootTitle: A,
            parentTitle: m,
            parentId: C
          },
          !1
        )
      )
    );
  }, [
    a,
    R == null ? void 0 : R.name,
    e,
    C,
    m,
    f,
    T,
    A,
    h
  ]);
  const le = te(() => e === "new" ? !1 : B || k || !(Y != null && Y.update), [Y == null ? void 0 : Y.update, e, B, k]), ae = te(
    () => dn(R),
    [R]
  ), H = he(() => D === ne.STUDY ? `study-manager/${C}/concept-sets` : "workspace/concept-sets", [C, D]), Ee = he(() => D === ne.LIBRARY ? new Promise((p) => {
    let I = !1;
    const v = (M) => {
      I || (I = !0, c(), p(M));
    };
    d(
      () => /* @__PURE__ */ n.jsx(
        Ca,
        {
          onCancel: () => v(void 0),
          onSave: (M) => v(M)
        }
      ),
      "Create concept set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: () => v(void 0)
      }
    );
  }) : new Promise((p) => {
    let I = !1;
    const v = (M) => {
      I || (I = !0, c(), p(M));
    };
    d(
      () => /* @__PURE__ */ n.jsx(
        E.concept,
        {
          type: "component",
          name: "concept-set-form",
          subModules: E,
          config: {
            typeContainer: D,
            parentId: C,
            onCancel: () => v(void 0),
            onSave: (M) => v(pa(M))
          }
        }
      ),
      "Create concept set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: () => v(void 0)
      }
    );
  }), [c, d, C, E, D]);
  he(
    (p) => {
      const I = [p == null ? void 0 : p.uuid, p == null ? void 0 : p.externalId, p == null ? void 0 : p.id].map(
        (M) => typeof M == "string" ? M.trim() : typeof M == "number" ? String(M) : ""
      ).find(Dr);
      if (!I) {
        i({
          message: "Concept set is not available for editing yet.",
          variant: "error"
        });
        return;
      }
      const v = H();
      d(
        () => /* @__PURE__ */ n.jsx(
          ha,
          {
            subModules: E,
            typeContainer: D,
            parentId: C,
            conceptSetId: String(I),
            conceptSetModulePath: v,
            storage: j,
            initStorage: L,
            onClose: c,
            onConceptSetSaved: (M) => {
              b((se) => ({
                ...se,
                conceptSets: ya(
                  se.conceptSets || [],
                  M,
                  {
                    id: p == null ? void 0 : p.id,
                    uuid: p == null ? void 0 : p.uuid,
                    externalId: p == null ? void 0 : p.externalId
                  }
                )
              }));
            }
          }
        ),
        "Concept sets",
        {
          closeOnClickOutside: !1,
          width: "95%",
          onClose: c
        }
      );
    },
    [
      c,
      i,
      H,
      L,
      d,
      C,
      j,
      E,
      D
    ]
  ), de(() => {
    !ae && t.pathname.endsWith("/concept-sets") && s(`/${f}/${e}`, { replace: !0 });
  }, [e, t.pathname, s, f, ae]);
  const Ne = te(() => {
    var v;
    const p = ((v = R == null ? void 0 : R.conceptSets) == null ? void 0 : v.length) || 0, I = [
      {
        title: "Definition",
        value: "",
        end: !0
      }
    ];
    return ae && I.push({
      title: /* @__PURE__ */ n.jsx(
        Ts,
        {
          title: "Concept Sets",
          count: p,
          status: re.SUCCESS,
          dense: !0
        }
      ),
      value: "concept-sets",
      end: !1
    }), I;
  }, [(Ur = R == null ? void 0 : R.conceptSets) == null ? void 0 : Ur.length, ae]), Ge = te(
    () => !Fr(
      Ce(ee),
      Ce(R)
    ),
    [R, ee]
  ), Zt = async (p) => {
    const I = Ta(p);
    if (I.length > 0) {
      i({
        message: I[0],
        variant: "error"
      });
      return;
    }
    P(!0);
    try {
      await fa(p);
      const v = e === "new" ? Ce(p) : un(ee, p), M = await $.upsertMethod(v, e), se = Ea(
        ye(M),
        p
      );
      ie(
        zr(M == null ? void 0 : M.actions, (se == null ? void 0 : se.id) || e)
      ), J(se), b(se), o(!1), i({
        message: "Custom feature saved successfully.",
        variant: "success"
      }), e === "new" && (se != null && se.id) && s(`../${se.id}`, { replace: !0 });
    } catch (v) {
      i({
        message: rr(v),
        variant: "error"
      });
    } finally {
      P(!1);
    }
  }, es = () => {
    l(As, {
      onSubmit: async () => {
        try {
          await $.deleteMethod(R.id), u(), i({
            message: `Feature analysis ${(R == null ? void 0 : R.name) || ""} is deleted`,
            variant: "success"
          }), s(`/${f}`);
        } catch (p) {
          u(), i({
            message: rr(p),
            variant: "error"
          });
        }
      },
      onClose: u,
      text: `Are you sure you want to delete ${(R == null ? void 0 : R.name) || "this custom feature"}?`,
      confirmButtonText: "DELETE"
    });
  }, rs = () => {
    d(
      () => /* @__PURE__ */ n.jsx(
        gs,
        {
          propId: "featureAnalysisId",
          onClose: c,
          item: R,
          inviteMethod: jn
        }
      ),
      "Publish custom feature",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: c
      }
    );
  }, ts = () => {
    d(
      () => /* @__PURE__ */ n.jsx(
        xs,
        {
          id: R.id,
          name: R.name,
          parentId: C,
          currentContainer: D,
          createCopyMethod: Un,
          typeEntity: "feature-analyses",
          onChange: c
        }
      ),
      "Export custom feature",
      {
        closeOnClickOutside: !0,
        onClose: c
      }
    );
  };
  if (Q === re.ERROR) {
    if (!g && e === "new")
      return /* @__PURE__ */ n.jsx(ve, { children: /* @__PURE__ */ n.jsx(
        tr,
        {
          status: 403,
          statusText: "Forbidden",
          message: "You do not have permission to create custom features.",
          data: null,
          path: f
        }
      ) });
    const p = (U == null ? void 0 : U.response) || {
      status: 500,
      statusText: "Internal Server Error",
      message: rr(U),
      data: null
    };
    return /* @__PURE__ */ n.jsx(ve, { children: /* @__PURE__ */ n.jsx(tr, { ...p, path: f }) });
  }
  return Q === re.INITIAL || Q === re.IN_PROGRESS ? /* @__PURE__ */ n.jsx(tt, { children: /* @__PURE__ */ n.jsx(_e, { size: 62 }) }) : /* @__PURE__ */ n.jsxs(y, { container: !0, px: 6, flexGrow: 1, flexDirection: "column", children: [
    /* @__PURE__ */ n.jsx(st, { children: /* @__PURE__ */ n.jsx(
      sa,
      {
        feature: R,
        viewMode: le,
        canDelete: !!(e !== "new" && (Y != null && Y.delete)),
        canPublish: e !== "new" && D === ne.LIBRARY && !B,
        canExport: !!(e !== "new" && [ne.STUDY, ne.WORKSPACE].includes(
          D
        ) && (Y != null && Y.update)),
        additionalActions: B && /* @__PURE__ */ n.jsx(
          E.library,
          {
            type: "component",
            name: "answer-publish-widget",
            subModules: E,
            config: {
              ...S,
              type: r.get("typePublish"),
              typeEntity: bs.FEATURE_ANALYSIS,
              nameEntity: R == null ? void 0 : R.name,
              id: r.get("id"),
              isRedirect: !0,
              requestStatus: r.get("status")
            }
          }
        ),
        versionPreview: k,
        onVersionRevert: () => {
          b(ee), o(!1);
        },
        disableSave: !Ge || oe,
        disablePublish: Ge || oe,
        onNameChange: (p) => b((I) => ({
          ...I,
          name: p
        })),
        onDescriptionChange: (p) => b((I) => ({
          ...I,
          description: p
        })),
        onSave: () => Zt(R),
        onDelete: es,
        onPublish: rs,
        onExport: ts
      }
    ) }),
    /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(
      Jt,
      {
        feature: R,
        viewMode: le,
        onDomainChange: (p) => b((I) => ({
          ...I,
          domain: p
        })),
        onAnalysisTypeChange: (p) => b(
          (I) => or(I, p)
        )
      }
    ) }),
    /* @__PURE__ */ n.jsxs(y, { item: !0, xs: 12, children: [
      /* @__PURE__ */ n.jsx(Zr, { tabs: Ne, withRouting: !0, secondary: !0 }),
      /* @__PURE__ */ n.jsx(ms, {})
    ] }),
    /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, pt: 0, pb: 2, children: /* @__PURE__ */ n.jsxs(ct, { children: [
      /* @__PURE__ */ n.jsx(
        qe,
        {
          index: !0,
          element: /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(
            Kt,
            {
              feature: R,
              subModules: E,
              typeContainer: D,
              parentId: C,
              viewMode: le,
              hideControls: !0,
              onDomainChange: (p) => b((I) => ({
                ...I,
                domain: p
              })),
              onAnalysisTypeChange: (p) => b(
                (I) => or(I, p)
              ),
              onCriteriaGroupsChange: (p) => b((I) => ({
                ...I,
                definition: {
                  ...I.definition,
                  criteriaGroups: p
                }
              })),
              onConceptSetsChange: (p) => b((I) => ({
                ...I,
                conceptSets: p
              })),
              onSqlChange: (p) => b((I) => ({
                ...I,
                definition: {
                  ...I.definition,
                  sql: p
                }
              }))
            }
          ) })
        }
      ),
      ae && /* @__PURE__ */ n.jsx(
        qe,
        {
          path: "concept-sets/*",
          element: /* @__PURE__ */ n.jsx(
            E.concept,
            {
              type: "component",
              name: "concept-set-sections-widget-new",
              subModules: E,
              config: {
                ...S,
                onChange: (p) => {
                  b((I) => {
                    const v = {
                      ...I,
                      conceptSets: p
                    };
                    return Fr(
                      Ce(I),
                      Ce(v)
                    ) ? I : v;
                  });
                },
                conceptSets: R.conceptSets || [],
                viewMode: le,
                exportConceptSet: !0,
                circleMode: !0,
                hideSectionContent: !0,
                hideAddConceptSetAction: D === ne.LIBRARY,
                hideCopySectionAction: !0,
                hideEditSectionAction: !0,
                onAddConceptSet: Ee
              }
            }
          )
        }
      )
    ] }) })
  ] });
}, ga = {
  rowId: "id",
  loadingMessage: "Loading feature analysis...",
  addButtonTitle: "Add feature analysis",
  tableTitle: "Feature analyses",
  importButtonTitle: "Import",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createCrudMethod: (e, r) => nt(
    e,
    r,
    Ye,
    () => Promise.resolve(),
    () => Promise.resolve(""),
    Ye,
    Ye
  ),
  createSortingMethod(e) {
    return Ar(e, {
      getSorting: Bt
    });
  },
  createFiltersPanel: (e, r) => We(
    e,
    r,
    () => Promise.resolve(""),
    () => Promise.resolve(""),
    () => Promise.resolve(""),
    Pt
  )
}, Aa = () => {
  const e = Te(
    ke
  );
  return /* @__PURE__ */ n.jsx(
    rt,
    {
      isImport: !1,
      moduleConfig: e,
      listConfig: ga,
      allowDelete: !0
    }
  );
}, Ra = "New feature analysis", Wr = {
  createCrudEntity: (e, r) => it(
    e,
    r,
    jr,
    () => Promise.resolve(),
    () => Promise.resolve()
  ),
  entityBreadcrumbs: (e, r, t, s) => at(Ra, e, r, t)
};
Hr({});
const Ia = (e) => {
  var t;
  const r = (t = e == null ? void 0 : e.expression) == null ? void 0 : t.items;
  return Array.isArray(r) ? r.length : r && typeof r == "object" ? Object.keys(r).length : 0;
}, ba = (e) => e ? Array.isArray(e) ? e.map((r) => ({
  concept: (r == null ? void 0 : r.concept) || {},
  includeDescendants: (r == null ? void 0 : r.includeDescendants) ?? (r == null ? void 0 : r.descendants) ?? !1,
  includeMapped: (r == null ? void 0 : r.includeMapped) ?? (r == null ? void 0 : r.mapped) ?? !1,
  isExcluded: (r == null ? void 0 : r.isExcluded) ?? (r == null ? void 0 : r.excluded) ?? !1,
  hierarchy: (r == null ? void 0 : r.hierarchy) ?? !1,
  id: r == null ? void 0 : r.id
})) : typeof e == "object" ? Object.values(e).map((r) => ({
  concept: (r == null ? void 0 : r.concept) || {},
  includeDescendants: (r == null ? void 0 : r.includeDescendants) ?? (r == null ? void 0 : r.descendants) ?? !1,
  includeMapped: (r == null ? void 0 : r.includeMapped) ?? (r == null ? void 0 : r.mapped) ?? !1,
  isExcluded: (r == null ? void 0 : r.isExcluded) ?? (r == null ? void 0 : r.excluded) ?? !1,
  hierarchy: (r == null ? void 0 : r.hierarchy) ?? !1,
  id: r == null ? void 0 : r.id
})) : [] : [], we = (e) => typeof e == "object" && e !== null, _a = (e, r) => r.reduce(
  (t, s) => we(t) ? t[s] : void 0,
  e
), Oa = (e) => Array.isArray(e) ? e.length > 0 : e && typeof e == "object" ? Object.keys(e).length > 0 : !1, va = (e) => {
  const r = [
    ["items"],
    ["expression", "items"],
    ["conceptSet", "items"],
    ["conceptSet", "expression", "items"],
    ["conceptSetVersion", "items"],
    ["conceptSetVersion", "expression", "items"],
    ["version", "items"],
    ["version", "expression", "items"]
  ];
  for (const t of r) {
    const s = _a(e, t);
    if (Oa(s))
      return s;
  }
}, Sa = (e) => {
  const r = we(e) && we(e.data) ? e.data : we(e) ? e : {}, t = we(r.conceptSet) ? r.conceptSet : r;
  return {
    name: typeof r.name == "string" ? r.name : typeof t.name == "string" ? t.name : void 0,
    items: va(r),
    versionOrdinal: r.ordinal ?? r.versionOrdinal ?? r.version ?? t.ordinal ?? t.versionOrdinal ?? t.version
  };
}, Na = async (e) => {
  const r = e == null ? void 0 : e.conceptSets;
  if (!Array.isArray(r) || r.length === 0)
    return e;
  const t = await Promise.all(
    r.map(async (s) => {
      if (Ia(s) > 0)
        return s;
      try {
        const a = (s == null ? void 0 : s.referenceId) || (s == null ? void 0 : s.uuid) || (s == null ? void 0 : s.id), i = s != null && s.versionId ? await Ht(String(s.versionId)) : a ? await vn(String(a)) : null, l = Sa(i);
        return {
          ...s,
          name: l.name ?? s.name,
          expression: {
            ...s.expression,
            items: ba(l.items)
          },
          versionOrdinal: l.versionOrdinal ?? s.versionOrdinal,
          version: l.versionOrdinal ?? s.version
        };
      } catch {
        return s;
      }
    })
  );
  return {
    ...e,
    conceptSets: t
  };
}, ja = () => {
  const { id: e } = ut(), r = dt(), { rootSettings: t, path: s, title: a, config: i, subModules: l } = Te(
    ke
  ), { rootPath: u, rootTitle: d } = t, { parentId: c, parentTitle: x, typeContainer: f } = i, h = f === ne.LIBRARY, S = te(
    () => Wr.createCrudEntity(f, c),
    [c, f]
  ), { entity: E, isVersionMode: j, status: L, error: T, revertEntity: A } = ls(
    {
      get: S.getMethod,
      update: S.upsertMethod,
      delete: S.deleteMethod
    },
    e,
    "Features"
  ), C = te(
    () => E ? ye(E) : null,
    [E]
  ), [m, D] = G(null);
  de(() => {
    let Z = !0;
    return (async () => {
      if (!C) {
        D(null);
        return;
      }
      const b = await Na(
        C
      );
      Z && D(b);
    })(), () => {
      Z = !1;
    };
  }, [C]);
  const $ = Rs(
    E == null ? void 0 : E.id,
    h && !!m && m.subtype !== N.PRESET,
    s
  ), Q = E == null ? void 0 : E.type, V = f === ne.LIBRARY && [me.CRITERIA_SET, me.CUSTOM_FE].includes(
    Q
  ), U = () => {
  };
  return de(() => {
    E && r(
      pt(
        Wr.entityBreadcrumbs(
          e,
          E == null ? void 0 : E.name,
          {
            path: s,
            title: a,
            rootPath: u,
            rootTitle: d,
            parentTitle: x,
            parentId: c
          },
          h
        )
      )
    );
  }, [
    r,
    E,
    e,
    c,
    x,
    s,
    u,
    d,
    a,
    h
  ]), L === re.ERROR ? /* @__PURE__ */ n.jsx(ve, { children: /* @__PURE__ */ n.jsx(tr, { ...T.response, path: s }) }) : L === re.INITIAL || L === re.IN_PROGRESS ? /* @__PURE__ */ n.jsx(tt, { children: /* @__PURE__ */ n.jsx(_e, { size: 62 }) }) : /* @__PURE__ */ n.jsxs(y, { container: !0, px: 6, flexGrow: 1, flexDirection: "column", children: [
    /* @__PURE__ */ n.jsx(st, { children: /* @__PURE__ */ n.jsx(
      Is,
      {
        entity: E,
        onSubmit: () => {
        },
        onCopy: () => {
        },
        versionPreview: j,
        onVersionRevert: A,
        onVersionSave: () => {
        },
        viewMode: h,
        disableSave: !0,
        onDelete: () => {
        },
        onPublish: () => {
        },
        onArchive: $
      }
    ) }),
    V && m && /* @__PURE__ */ n.jsx(y, { item: !0, xs: 12, py: 2, children: /* @__PURE__ */ n.jsx(
      Kt,
      {
        feature: m,
        subModules: l,
        typeContainer: f,
        parentId: c,
        viewMode: !0,
        onDomainChange: U,
        onAnalysisTypeChange: U,
        onCriteriaGroupsChange: U,
        onConceptSetsChange: U,
        onSqlChange: U
      }
    ) })
  ] });
}, ke = Hr(null), Da = (e) => {
  var h;
  const { path: r, title: t, name: s, storage: a, rootSettings: i, initStorage: l } = e, u = ((h = e.config) == null ? void 0 : h.featureEntitySource) === "draft", [d, c] = G(i), [x, f] = G(!0);
  return de(() => {
    i || c({
      rootPath: r,
      rootTitle: t
    }), f(!1);
  }, []), x ? /* @__PURE__ */ n.jsx(ve, { children: /* @__PURE__ */ n.jsx(_e, { size: 32 }) }) : /* @__PURE__ */ n.jsx(ke.Provider, { value: { ...e, rootSettings: d }, children: /* @__PURE__ */ n.jsxs(ct, { children: [
    /* @__PURE__ */ n.jsx(
      qe,
      {
        index: !0,
        element: u ? /* @__PURE__ */ n.jsx(Zn, {}) : /* @__PURE__ */ n.jsx(Aa, {})
      }
    ),
    /* @__PURE__ */ n.jsx(
      qe,
      {
        path: ":id/*",
        element: u ? /* @__PURE__ */ n.jsx(xa, {}) : /* @__PURE__ */ n.jsx(ja, {})
      }
    )
  ] }) });
}, Ya = (e) => {
  const { type: r } = e;
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    !r && /* @__PURE__ */ n.jsx(Da, { ...e }),
    r === "component" && /* @__PURE__ */ n.jsx(Xn, { ...e })
  ] });
};
export {
  z as CustomFeatureImportSource,
  Ya as FeatureAnalyses
};
//# sourceMappingURL=feature-analyses.js.map
